import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const LANG_KEY = "lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "sv"],
    returnNull: false,
    detection: {
      order: ["localStorage", "navigator"], // checks localStorage first, then browser
      caches: ["localStorage"],             // stores selected lang in localStorage
      lookupLocalStorage: LANG_KEY,
    },
    resources: {
      en: {
        translation: {
          pageLanding: {
            welcome: "Welcome to Mini Backoffice",
            // ...
          },
          common: {
            sales: "Sales",
            purchase: "Purchase",
            inventory: "Inventory",
            history: "History",
            order: "Order",
            invoice: "Invoice",
            credit: "Credit",
            shipment: "Shipment",
            customers: "Customers",
            item: "Item",
            items: "Items",
            itemLabels: "Item Labels",
            open: "Open",
            created: "Created",
            copies: "Copies",
            templates: "Templates",
            template: "Template",
            number: "Number",
            print: "Print",
            price: "Price",
            pricelist: "Pricelist",
            salesPriceImport: "Sales price import",
            originalPrice: "Original Price",
            priceGroupA: "Price Group A",
            priceGroupB: "Price Group B",
            currenciesA: "Currencies A",
            currenciesB: "Currencies B",
            includeVat: "Include VAT",
            shelf: "Shelf",
            colour: "Colour",
            size: "Size",
            length: "Length",
            add: "Add",
            added: "Added",
            changesSaved: "Changes saved",
            selectTemplate: "Select template",
            printQueued: "Print job queued",
            fetchDataError: "Failed to fetch data",
            createError: "Failed to create",
            saveError: "Failed to save",
            addError: "Failed to add",
            deleteError: "Failed to delete",
            printError: "Failed to print",
            locationRequired: "Location is required",
            copiesCleared: "Copies cleared",
            operationFailed: "Operation failed",
            missingDocument: "Missing document",
            chooseFile: "Choose file",
            validate: "Validate",
            addLines: "Add Lines",
            addFromInventory: "Add from inventory",
            clearCopies: "Clear copies",
            removeAllLines: "Remove all lines",
            noData: "No data available",
            notSet: "Not set",
            header: "Header",
            initCode: "Init code",
            externalValue1: "Extra external value 1",
            partition: "Unifaun partition name",
            favorite: "Unifaun print favourite name",
            dateTime: "Date and time of label creation",

            supplier: "Supplier",
            suppliers: "Suppliers",
            integration: "Integration",
            integrations: "Integrations",
            orders: "Orders",
            batches: "Batches",
            bonusBatch: "Bonus batch",
            bonusSystem: "Bonus system",
            bonusGroup: "Bonus group",
            bonusPoints: "Bonus points",
            bonusLadder: "Bonus ladder",
            bonusRate: "Bonus rate",
            calculationInterval: "Calculation interval",
            continuous: "Continuous",
            period: "Period",
            validDays: "Valid days",
            reservationAccount: "Reservation account",
            reservedVatAccount: "Reserved VAT account",
            debtAccount: "Debt account",
            givesBonusAmount: "Gives bonus amount",
            bonusPointExchangeRate: "Bonus point exchange rate",
            calculateFromPreliminary: "Calculate from preliminary transactions",
            runBatch: "Run batch",
            selectBatch: "Select a batch to view results",
            lines: "Lines",
            importLines: "Import lines",
            onlyErrors: "Only errors",
            settings: "Settings",
            itemDimensions: "Item Dimensions",
            colourGroup: "Colour Group",
            sizeGroup: "Size Group",
            lengthGroup: "Length Group",
            itemGroup: "Item Group",
            itemCategory: "Item Category",
            productGroup: "Product Group",
            program: "Program",
            collection: "Collection",
            statNo: "Stat No",
            transactions: "Transactions",
            invAdjustment: "Inventory Adjustment",
            general: "General",
            company: "Company",
            country: "Country",
            countryCode: "Country Code",
            currency: "Currency",
            language: "Language",
            languageCulture: "Language Culture",
            businessSettings: "Business Settings",
            account: "Account",
            paymentTerminal: "Payment Terminal",
            postingSetup: "Posting Setup",
            salesperson: "Salesperson",
            shop: "Shop",
            terminal: "Terminal",
            warehouse: "Warehouse",
            location: "Location",
            printer: "Printer",
            shippingAgent: "Shipping Agent",
            administration: "Administration",
            metrics: "Metrics",
            users: "Users",
            username: "Username",
            password: "Password",
            login: "Login",
            logout: "Log Out",
            finance: "Finance",
            value: "Value",
            qty: "Quantity",
            summary: "Summary",
            select: "Select",
            from: "From",
            to: "To",
            status: "Status",
            processed: "Processed",
            unprocessed: "Unprocessed",
            pending: "Pending",
            create: "Create",
            search: "Search",
            searchOrders: "Search Orders",
            fetchMore: "Fetch more",
            clear: "Clear",
            results: "Results",
            identifier: "Identifier",
            priority: "Priority",
            keyword: "Keyword",
            type: "Type",
            url: "URL",
            icon: "Icon",
            customerNo: "Customer No",
            customerContact: "Ship-to contact name",
            customerFax: "Customer fax no.",
            customerOrgNo: "Customer organization no.",
            customerDoorcode: "Ship-to door code",
            customerEmail: "Customer e-mail",
            customerSms: "Ship-to mobile phone no.",
            customerVatNo: "Customer VAT no.",
            name: "Name",
            name2: "Name2",
            address: "Address",
            address2: "Address2",
            noOrdersFound: "No orders found",
            noOrderInBatch: "No order found to pick/pack, please add order to batch.",
            previous: "Previous",
            next: "Next",
            view: "View",
            pageOf: "Page {{current}}/{{total}}",
            failedToCreateOrder: "Failed to create order",
            failedToFetchOrders: "Failed to fetch orders",
            documentSaved: "Document saved successfully!",
            unsavedChanges: "You have unsaved changes",
            failedToSaveDocument: "Failed to save document",
            failedToFetchSettings: "Failed to fetch updated settings",
            failedToPost: "Failed to post",
            failedToCancel: "Failed to cancel",
            failedToCopy: "Failed to copy",
            failedToPrint: "Failed to print",
            failedToSendEmail: "Failed to send email",
            failedToIntegrate: "Failed to integrate",

            orderNo: "Order No",
            orderBatchNo: "Source document order batch ID",
            orderAmount: "CoD amount",
            sellToCustomerNo: "Ordered by Customer No",
            billToCustomerNo: "Billed to Customer No",
            showCustomerInfo: "Show Customer Information",
            sellToCustomerName: "Ordered by - Customer Name",
            billToCustomerName: "Billed to - Customer Name",
            sellToCustomerName2: "Ordered by - Customer Name 2",
            billToCustomerName2: "Billed to - Customer Name 2",
            sellToCustomerAddress: "Ordered by - Address",
            billToCustomerAddress: "Billed to - Address",
            sellToCustomerAddress2: "Ordered by - Address 2",
            billToCustomerAddress2: "Billed to - Address 2",
            sellToCustomerPostCode: "Ordered by - Post Code",
            billToCustomerPostCode: "Bills to - Post Code",
            sellToCustomerCity: "Ordered by - City",
            billToCustomerCity: "Bills to - City",
            sellToCustomerContact: "Ordered by - Contact",
            billToCustomerContact: "Bills to - Contact",
            sellToCustomerMobile: "Ordered by - Mobile",
            billToCustomerMobile: "Bills to - Mobile",
            sellToCustomerEmail: "Ordered by - Email",
            billToCustomerEmail: "Bills to - Email",
            sellToCountry: "Ordered by - Country",
            billToCountry: "Bills to - Country",
            selltoCustomerNo: "Sell To Customer No",
            selltoCustomerName: "Sell To Customer Name",
            selltoAddress: "Sell To Address",
            selltoPostCode: "Sell To Post Code",
            selltoCity: "Sell To City",
            selltoCounty: "Sell To County",
            paymentTerms: "Payment Terms",


            orderDate: "Order Date",

            shipToName: "Ship to Name",


            shipToName2: "Ship to Name 2",


            shipToAddress: "Ship to Address",


            shipToAddress2: "Ship to Address 2",


            shipToMobile: "Ship to Mobile",


            shipToEmail: "Ship to Email",


            shipToCounty: "Ship to County",


            shipToPostCode: "Ship to Postcode",


            shipToCity: "Ship to City",

            shipToCountry: "Ship to Country",
            shipToCustomerName: "Ship-to name",
            shipToCustomerName2: "Ship-to name 2",
            shipToCustomerAddress: "Ship-to address",
            shipToCustomerAddress2: "Ship-to address 2",
            shipToCustomerPostCode: "Ship-to postcode",
            shipToCustomerCity: "Ship-to city",
            shipToCustomerCounty: "Ship-to county",
            shipToCustomerCountryCode: "Ship-to country code",


            emailShipment: "Email Shipment",

            shipmentDate: "Shipment Date",
            parcelGrossWeight: "Parcel gross weight",
            parcelVolume: "Parcel volume",
            parcelLength: "Parcel length",
            parcelWidth: "Parcel width",
            parcelHeight: "Parcel height",
            parcelContents: "Parcel contents",
            parcelPackageCode: "Parcel package code",

            shippingService: "Shipping Service",


            showPayments: "Show Payments",
            paymentMethod: "Payment Method",
            amount: "Amount",
            payments: "payments",
            post: "Post",
            cancel: "Cancel",
            cancel_mak: "Cancel",
            copy: "Copy",
            delete: "Delete",
            anonymizePersonalData: "Anonymize Personal Data (GDPR)",
            sendEmail: "Send Email",
            integrate: "Integrate",
            integrated: "Integrated",
            integrateTa: "Integrate TA",
            edit: "Edit",

            noImage: "No Image Available",
            barcode: "Barcode",

            unitPrice: "Unit Price",
            discount: "Discount",
            editLine: "Edit Line",
            itemNo: "Item No",
            accountNo: "Account No",
            certificateAccount: "Certificate Account",
            description: "Description",
            quantity: "Quantity",
            qtyToShip: "Qty to Ship",
            lineDiscount: "Line Discount",
            save: "Save",
            certificateCode: "Certificate Code",
            actions: "Actions",
            initiate: "Initiate",
            mobileNumber: "Mobile Number",
            showCertificates: "Show Certificates",
            createPayment: "Create Payment",
            editPayment: "Edit Payment",
            searchItems: "Search Items",
            noItemsFound: "No items found",
            uploadImage: "Upload Image",
            description2: "Description 2",
            supplierItemNo: "Supplier Item No",
            salesPrice: "Sales Price",
            salesPriceCurrency: "Sales Price Currency",
            purchasePrice: "Purchase Price",
            purchasePriceCurrency: "Purchase Price Currency",
            showCustoms: "Show Customs",
            netWeight: "Net Weight",
            grossWeight: "Gross Weight",
            volume: "Volume",
            countryOfOrigin: "Country of Origin",
            blocked: "Blocked",
            salesBlocked: "Sales Blocked",
            manageVariants: "Manage Variants",
            close: "Close",
            back: "Back",
            saving: "Saving...",
            itemInfo: "Item Info",
            pricing: "Pricing",
            variantGroups: "Variant Groups",
            variants: "Variants",
            addSplitLine: "Return Another Item",
            cancelWizard: "Cancel Wizard",
            finish: "Finish",
            variant: "Variant",
            editVariant: "Edit Variant",
            page: "Page",
            deleted: "Deleted",
            yes: "Yes",
            no: "No",
            noEntriesFound: "No entries found",
            enterNewUser: "Enter a New User",
            newUsername: "New Username",
            newPassword: "New Password",
            editUser: "Edit User",
            email: "Email",
            admin: "Admin",
            printers: "Printers",
            itemLabelPrinter: "Item label printer",
            shipmentLabelPrinter: "Shipment label printer",
            addressLabelPrinter: "Address label printer",
            a4Printer: "A4 printer",
            a5Printer: "A5 printer",
            selectJournalType: "Select Journal Type",
            stockTaking: "StockTaking",
            adjustment: "Adjustment",
            receival: "Receival",
            journalTypeDescriptions: {
              Adjustment: "Adjustment",
              TransferIn: "Transfer In",
              TransferOut: "Transfer Out",
              Purchase: "Receival",
              Stocktaking: "Stocktaking",
              Invoice: "Invoice",
              Credit: "Credit",
              Revaluation: "Revaluation",
              RevaluationCurrency: "Revaluation (Currency)",
              RevaluationValue: "Revaluation (Value)",
              ShelfMove: "Shelf Move",
            },
            editJournal: "Edit Journal",
            journal: "Journal",
            loadingdotdot: "loading...",
            selectPostingMode: "Select posting mode",
            postIncluded: "Post Only Included Items",
            includeAndZero: "Include and zero any non scanned items",
            documentNo: "Document No",
            addItems: "Add Items",
            showAdvancedSettings: "Show Advanced Settings",
            inventoryDate: "Inventory Date",
            searchForItem: "Search for item",
            toggleListMode: "Toggle ListMode",
            cancelFocus: "Cancel Focus",
            estimatedQty: "Estimated Qty.",
            physicalQty: "Physical Qty.",
            costAmount: "Cost Amount",
            saveChanges: "Save Changes",
            deleteAll: "Delete All",
            customer: "Customer",
            postingDate: "Posting Date",
            advancedFilter: "Advanced Filter",
            fetch: "Fetch",
            addProductGroupSetting: "Add Product Group Setting",
            setting: "Setting",
            dateFrom: "Date From",
            dateTo: "Date To",
            generateReport: "Generate Report",
            salesDistribution: "Sales Distribution",
            itemReport: "Item Report",
            totalSum: "Total Sum",
            removeFromGraph: "Remove from graph",
            addToGraph: "Add to graph",
            amountIncVat: "Amount Inc VAT",
            cbMargin: "CB Margin",
            cbPercent: "CB %",
            openShippingForm: "Open Shipping Form",
            openReturnForm: "Open Return Form",
            openShippingLabel: "Open Shipping Label",
            openReturnLabel: "Open Return Label",
            openInPack: "Open In Pack",
            openBatch: "Open Batch",
            openPick: "Open Pick",
            openPack: "Open Pack",
            openNextOrder: "Open Next Order",
            addOrderToBatch: "Add Order",
            orderAddedToBatch: "Order added to batch",
            confirmAddOrder: "Add order {{orderNo}} to batch {{batchId}}?",
            basket: "Basket",
            printShippingLabel: "Print Shipping Label",
            printReturnLabel: "Print Return Label",

            contents: "Contents",
            width: "Width",
            height: "Height",
            packageType: "Package Type",
            tracking: "Tracking",
            parcelCode: "Parcel Code",
            setupInitialCompany: "Setup Initial Company settings",
            postCode: "PostCode",
            city: "City",
            defaultCurrency: "Default Currency",
            baseColour: "Basecolor",
            editColour: "Edit Colour",
            editColourGroup: "Edit Colourgroup",
            base: "Base",
            editLengthGroup: "Edit Length Group",
            editSizeGroup: "Edit Size Group",
            none: "None",
            itemLedger: "Item Ledger",
            remainingQuantity: "Remaining Quantity",
            shipmentMethod: "Shipment Method",
            shipmentNo: "Shipment No",
            shipToCustomer: "Ship to Customer",
            showShippingInfo: "Show Shipping Information",
            showParcels: "Show Parcels",
            contact: "Contact",
            invoiceDiscountGroup: "Invoice Discount Group",
            postingSetupWho: "Posting Setup Who",
            invoices: "Invoices",
            credits: "Credits",
            setupSuccessTitle: "Congratulations on a successful setup!",
            setupSuccessText: "Everything is ready 🎉 If you'd like, you can now:",
            createItem: "Create an item",
            createFirstOrder: "Create your first order",
            runSalesReport: "Run sales report",
            goToStart: "Go To Start",
            loginFailed: "Login failed.",
            failedToFetchEntries: "Failed to fetch entries",
            newAccountNo: "New Account No",
            newAccountDescription: "New Account Description",
            accountType: "Account Type",
            postingSetupWhat: "Posting Setup What",
            showSettings: "Show Settings",
            showTransactions: "Show Transactions",
            locked: "Locked",
            handled: "Handled",
            notified: "Notified",
            vatDeclarationCode: "Vat Declaration Code",
            ossType: "Oss Type",
            sru: "SRU",
            companies: "Companies",
            unit: "Unit",
            enterNewUnit: "Enter a New Unit",
            newUnit: "New Unit",
            customerPostingGroup: "Customer Posting Group",
            supplierPostingGroup: "Supplier Posting Group",
            testCompany: "Test Company",
            showContactSettings: "Show Contact Settings",
            seat: "Seat",
            customerServicePhone: "Customer Service Phone",
            customerServiceEmail: "Customer Service Email",
            senderEmail: "Sender Email",
            website: "Website",
            showFinanceSettings: "Show Finance Settings",
            orgNo: "Org no.",
            vatNo: "Vat No.",
            code: "Code",
            newCode: "New Code",
            confirm: "Confirm",
            region: "Region",
            templateCustomerB2C: "Template Customer - B2C",
            callingCode: "Calling Code (Phone)",
            createOcr: "Create OCR",
            customsInvoice: "Customs Invoice",
            createReturnDocument: "Create Return Document",
            currencyCode: "Currency Code",
            customsCurrencyUnit: "Currency code",
            symbol: "Symbol",
            rate: "Rate",
            validFrom: "Valid From",
            currencyAccount: "Currency Account",
            roundingPos: "Rounding POS",
            decimalScale: "Decimal Scale",
            locations: "Locations",
            showAccounts: "Show Accounts",
            inventoryAccount: "Inventory Account",
            transferBalanceAccount: "Transfer Balance Account",
            default: "Default",
            consumer: "Consumer",
            business: "Business",
            paymentTerminals: "Payment Terminals",
            paymentProvider: "Payment Provider",
            paymentProviderSetting: "Payment Provider Setting",
            cardTerminalId: "Card Terminal Id",
            startDate: "Start Date",
            endDate: "End Date",
            vatPercentage: "VAT %",
            vatType: "Vat Type",
            salesAccount: "Sales Account",
            salesCreditAccount: "Sales Credit Account",
            salesDiscountAccount: "Sales Discount Account",
            salesVatAccount: "Sales VAT Account",
            showMoreSettings: "Show More Settings",
            purchaseAccount: "Purchase Account",
            purchaseCreditAccount: "Purchase Credit Account",
            purchaseDiscountAccount: "Purchase Discount Account",
            purchaseReceivalAccount: "Purchase Receival Account",
            purchaseOverheadAccount: "Purchase Overhead Account",
            purchaseVatAccount: "Purchase VAT Account",
            purchaseReverseVatAccount: "Purchase Reverse VAT Account",
            cogsAccount: "COGS Account",
            inwardGoodsAccount: "Inward Goods Account",
            inwardServiceAccount: "Inward Service Account",
            inwardGoodsVatAccount: "Inward Goods VAT Account",
            inwardServiceVatAccount: "Inward Service VAT Account",
            inventoryValueAdjustmentAccount: "Inventory Value Adjustment Account No",
            purchaseOverheadCustomsAccount: "Purchase Overhead Customs Account",
            purchaseOverheadOtherAccount: "Purchase Overhead Other Account",
            purchaseOverheadFreightAccount: "Purchase Overhead Freight Account",
            externalReference: "External Reference",
            result: "Result",
            balance: "Balance",
            apiKey: "API Key",
            activatePrintNode: "Activate PrintNode",
            administrator: "Administrator",
            showPermissions: "Show Permissions",
            allowDiscount: "Allow Discount",
            allowPriceChange: "Allow Price Change",
            allowCashWithdrawal: "Allow Cash Withdrawal",
            services: "Services",
            returnLink: "Return Link",
            clickAndCollect: "Click and Collect",
            showReturnSettings: "Show Return Settings",
            returnName: "Return Name",
            returnName2: "Return Name 2",
            returnAddress: "Return Address",
            returnAddress2: "Return Address 2",
            returnPostcode: "Return Postcode",
            returnCity: "Return City",
            returnCounty: "Return County",
            returnCountry: "Return Country",
            showIntegrationSettings: "Show Integration Settings",
            connectedSystem: "Connected System",
            integrationEndpoint: "Integration EndPoint",
            integrationUsername: "Integration Username",
            integrationPassword: "Integration Password",
            entityCodeSame: "New code can not be the same as source",
            returnAsNormalShipment: "Return as normal shipment",
            showFreightDimensions: "Show Freight Dimension settings",
            standardWeight: "Standard Weight",
            minWeight: "Min. Weight",
            maxWeight: "Max Weight",
            maxLength: "Max Length",
            maxVolume: "Max Volume",
            showShipmentInfo: "Show Shipment information",
            useShipmentAddress: "Use Shipment Address",
            editor: "Editor",
            addSections: "Add Sections",
            addPdfConfig: "Add PdfConfig",
            addShipment: "Add Shipment",
            addAgent: "Add Agent",
            addCustomsDeclaration: "Add Customs Declaration",
            priceGroup: "Pricegroup",
            active: "Active",
            inactive: "Inactive",
            terminalNo: "TerminalNo",
            cashDrawer: "Cashdrawer",
            ccuId: "CCU ID",
            ccuUnit: "CCU Unit",
            apiSecret: "API Secret",
            installedOnUnit: "Installed on unit",
            installationDate: "Installation Date",
            cardTerminal: "Card Terminal",
            thermalPrinter: "Thermal printer",
            reports: "Reports",
            paymentProviderConfig: "Payment Provider Config",
            apiUsername: "API Username",
            apiPassword: "API Password",
            refundUrl: "Refund URL",
            settlementUrl: "Settlement URL",
            merchantAccount: "Merchant Account",
            refund: "Refund",
            settling: "Settling",
            selectPaymentProvider: "Select Payment Provider",
            pricesInclVat: "Prices Including VAT",
            home: "Home",
            paypalApiUsername: "PayPal API Username",
            paypalApiPassword: "PayPal API Password",
            paypalApiSignature: "PayPal API Signature",
            paymentProviderKey: "Payment Provider Key {{index}}",
            newDescription: "New Description",
            enterNewDescription: "Enter new description",
            enterNewAccountNo: "Enter new Account No.",
            klarnaInfo1: "Klarna Merchant ID",
            klarnaInfo2: "Klarna Shared Secret",
            klarnaInfo3: "Klarna API URL",
            klarnaInfo5: "Klarna Provider Type",
            klarnaInfo6: "Klarna Buy Terms URL",
            klarnaInfo7: "Klarna Confirmation Page URL",
            klarnaInfo8: "Klarna Checkout URL",
            klarnaInfo9: "Klarna Checkout URL (Alternate)",
            paymentType: "Payment Type",
            paymentType_None: "None",
            paymentType_Cash: "Cash",
            paymentType_VISA: "VISA",
            paymentType_MasterCard: "MasterCard",
            paymentType_Diners: "Diners Club",
            paymentType_AMEX: "AMEX",
            paymentType_Dankort: "Dankort",
            paymentType_CoD: "Cash on Delivery",
            paymentType_Facturing: "Facturing",
            paymentType_Downpayment: "Downpayment",
            paymentType_Giftcard: "Gift Card",
            paymentType_Creditnote: "Credit Note",
            paymentType_Maestro: "Maestro",
            paymentType_BABS: "BABS",
            paymentType_CHECK: "Check",
            paymentType_Invoice: "Invoice",
            paymentType_Credit: "Credit",
            paymentType_BankTransfer: "Bank Transfer",
            paymentType_RIKSGiftCard: "RIKS Gift Card",
            paymentType_MemberCard: "Member Card",
            paymentType_Manual: "Manual",
            paymentType_PayPal: "PayPal",
            paymentType_MoneyBookers: "MoneyBookers",
            paymentType_BonusCard: "Bonus Card",
            paymentType_BonusCheck: "Bonus Check",
            paymentType_BonusPoints: "Bonus Points",
            paymentType_InternalRefund: "Internal Refund",
            paymentType_ReplacementOrder: "Replacement Order",
            paymentType_MPOSBalance: "MPOS Balance",
            paymentType_Profile: "Profile",
            paymentType_QLIRO: "QLIRO",
            paymentType_Swish: "Swish",
            paymentType_MiscOption1: "Misc Option 1",
            paymentType_MiscOption2: "Misc Option 2",
            paymentType_MiscOption3: "Misc Option 3",
            balanceAccountNo: "Balance Account",
            global: "Global",
            retail: "Retail",
            mposManualCard: "Mpos Manual Card",
            phoneNo: "Phone No.",
            totalValue: "Total value",
            unitValue: "Unit value",
            inventoryValueReport: "Inventory value report",
            inventoryQtyReport: "Inventory Quantity report",
            available: "Available",
            reserved: "Reserved",
            inventoryValue: "Inventory value",
            debit: "Debit",
            accountSummary: "Account Summary",
            accountDimension: "Account Dimensions",
            count: "Count",
            date: "Date",
            orderCountOverTime: "Order Count Over Time",
            day: "Day",
            week: "Week",
            month: "Month",
            year: "Year",
            gender: "Gender",
            fullDescription: "Long Description (Body/HTML)",
            itemImport: "Item Import",
            import: "Import",
            export: "Export",
            uploadFile: "Upload File",
            fileName: "File Name",
            prices: "Prices",
            variantInfo: "Variant Information",
            dimensions: "Dimensions",
            stock: "Stock",
            stockInformation: "Stock information",
            showDescriptions: "Show Descriptions",
            showAll: "Show all Lines",
            showOnlyErrors: "Show only error lines",
            image: "Image",
            variantReport: "Variant Report",
            showExternalReferences: "Show External References",
            createReturn: "Create Return",
            info: "Information",
            trans: "Trans No.",
            refunded: "Refunded",
            returnLine: "Return Line",
            chooseRowsToReturn: "Choose Rows to Return",
            alreadyReturnedQuantity: "Already Returned Quantity",
            returnReason: "Return Reason",
            refundAmount: "Refund Amount",
            remainingAmount: "Remaining Amount",
            posted: "Posted",
            showReturns: "Show Returns",
            returnFreight: "Return Freight",
            amountToRefund: "Amount to Refund",
            returns: "Returns",
            noRowsLeftToReturn: "There are no rows left to return",
            returnStatus_10: "Approved",
            returnStatus_0: "Preliminary",
            returnStatus_: "Preliminary",
            returnStatus: "Return Status",
            show: "Show",
            showOtherReturns: "Show other Returns",
            showInvoicePayments: "Show Invoice Payments",
            showReplacement: "Show Replacement",
            createReplacementOrder: "Create Replacement Order",
            openReplacementOrder: "Open Replacement Order",
            replacementLines: "Replacement Lines",
            refundPayments: "Refunds",
            invoiceNo: "Invoice No.",
            returnNo: "Return No.",
            return: "Return",
            invoiceLines: "Invoice Lines",
            creditLines: "Credit Lines",
            cancelled: "Cancelled",
            creditedQuantity: "Credited Qty",
            refundedAmount: "Refunded Amount",
            editReturn: "Edit Return",
            saved: "Saved",
            field: "Field",
            showOrderInfo: "Show Order Info",
            showMoreInfo: "Show More Info",
            orderInfo: "Order Info",
            picked: "Picked",
            packed: "Packed",
            qtyToPick: "Quantity To Pick",
            qtyToPack: "Quantity To Pack",
            pick: "Pick",
            pack: "Pack",
            dispatch: "Dispatch",
            replacementOrder: "Replacement Order",
            showAdvancedControls: "Show Advanced Controls",
            scanOrClickToSetup: "Scan or Click to Setup MPOS",
            certificates: "Certificates",
            certificate: "Certificate",
            cancelCertificates: "Redeem certificates",
            cancelCertificatesDescription: "Redeem certificates that have expired up to the selected date.",
            startCancellation: "Start cancellation",
            progressAwaiting: "Waiting for progress update...",
            giftCard: "Gift card",
            downPayment: "Downpayment",
            settlementVoucher: "Settlement voucher",
            bonusCard: "Bonus card",
            bonusCheck: "Bonus check",
            loading: "Loading",
            appliesToDocumentNo: "Applies To Document No",
            clearFilter: "Clear Filter",
            install: "Install",
            key: "Key",
            reInstall: "Re Install",
            advanced: "Advanced",
            advancedUrls: "Advanced Urls",
            subScriberSettings: "Subscriber (events) settings",
            accountPlan: "Account Plan",
            tag: "Tag",
            systemLog: "System Log",
            message: "Message",
            method: "Method",
            error: "Error",
            archive: "Archive",
            createNew: "Create New",
            addColour: "Add Colour",
            addSize: "Add Size",
            addLength: "Add Length",
            fetchTransactionsFrom: "Fetch Transactions From",
            remainingAmountGTE: "Remaining Amount Greater Than",
            remainingAmountLTE: "Remaining Amount Less Than",
            updated: "Updated",
            createdby: "Created By",
            updatedby: "Updated By",
            showUserChangeInfo: "Show Change Info",
            redeem: "Redeem",
            redeemed: "Redeemed",
            importList: "Import list",
            foundErrors: "Found Errors",
            showVariants: "Show Variants",
            creditNo: "Credit No.",
            validUntil: "Valid Until",
            activated: "Activated",
            readyToShip: "Ready to ship",
            billToCustomer: "Bill To Customer",
            myUser: "My User",
            printTestLabel: "Print Test Label",
            labelSuggestAi: "Ask AI to suggest labeltemplate",
            labelChangeAi: "Ask AI to change labeltemplate",
            jsonSuggestAi: "Ask AI to suggest JSON config",
            jsonChangeAi: "Ask AI to change JSON config",
            run: "Run",
            request: "Request",
            itemLabelBarcodeType: "Barcode Type",
            scanBarcode: "Scan Barcode",
            scanAgain: "Scan again",
            scanningdotdot: "Scanning ...",
            showMore: "Show More",
            showLess: "Show Less",
            success: "Success",
            variables: "Variables",
            transfer: "Transfer",
            qtyToMove: "Qty to move",
            toLocation: "To Location",
            showAdvancedPrices: "Show Advanced Prices",
            createItemlabels: "Create Item Labels",
            createExchange: "Create Exchange",
            aiSuggest: "Ask AI for suggestion",
            updateExisting: "Update Current Item",
            help: "Help",
            county: "Region",
            inventoryDateLTE: "Inventory date To",
            inventoryDateGTE: "Inventory date From",
            moreSalesPrices: "More Salesprices",
            showContactInfo: "Show Contact Info",
            emailSenderAddress: "Email Sender Address",
            custServiceEmail: "Customer Service Email",
            custServicePhone: "Custome Service Phone",
            defaultEmail: "Default Email",
            requeue: "Requeue",
            requeueAll: "Requeue All",
            orderErrors: "Order Errors",
            showErrors: "Show Errors",
            details: "Details",
            setOrderAsSettled: "Set Order as Settled",
            qliroInfo1: "Qliro Url",
            qliroInfo2: "Qliro Merchant Api Key",
            qliroInfo3: "Qliro Secret",
            remaining: "Remaining",
            bonusAccount: "Bonus Account",
            externalCode: "External Code",
            salesPriceList: "Price list",
            noFileSelected: "No File Selected",
            importFile: "Import File",
            importData: "Import Data",
          },
          columns: {
            ext_Item: "Items",
            ext_IntegrateItems: "Integrate items",
            ext_Customer: "Customers",
            ext_SalesOrder: "Sales orders",
            ext_SalesOrderCancellation: "Sales order cancellation",
            ext_SalesOrderInspection: "Sales order inspection",
            ext_LockOrder: "Lock sales orders",
            ext_LockSalesLines: "Lock saleslines",
            ext_LegacyInvoiceBilled: "Sales invoice billed",
            ext_SalesReturnIntegrated: "Sales return integrated",
            ext_SalesReturnCreated: "Sales returns",
            ext_SalesReturnPostedTrx: "Sales return posted",
            ext_PurchaseOrder: "Purchase orders",
            ext_PurchaseOrderIntegrated: "Purchase orders integrated",
            ext_PurchaseOrderReceivedTrx: "Purchase order receival",
            ext_PurchaseReturn: "Purchase returns",
            ext_Inventory: "Inventory",
            ext_Shipment: "Shipments",
            ext_ShipmentTrackingUpdate: "Shipment tracking",
            ext_SalesOrderPickCompleted: "Sales order picking",
            ext_SalesOrderPackCompleted: "Sales order packing",
            ext_InternalOrderPosted: "Internal orders posted",
            ext_InternalOrderIntegrated: "Internal orders integrated",
            ext_ShelfMove: "Shelf move",
            ext_WarehouseLoadingCreated: "Warehouse loading orders",
          },

          integration: {
            bool_customer: "Interest in customer creation/updates",
            bool_salesorder: "Interest in new or updated sales orders (open)",
            bool_cancel: "Interest in cancelled sales orders",
            bool_inspection: "Interest in sales order inspection",
            bool_invoice: "Interest in posted invoices and credits",
            bool_lockorder: "Lock order for edit",
            bool_locklines: "Lock order lines for edit",
            bool_return: "Interest in integrated salesreturns",
            bool_returncreated: "Interest in newly created salesreturns",
            bool_postedreturn: "Interest in posted salesreturns",
            bool_item: "Interest in newly created/updated products",
            bool_purchaseorder: "Interest in newly created purchase orders",
            bool_purchaseManual: "Interest in integrated purchase orders",
            bool_receivepurchase: "Interest in received purchase orders",
            bool_purchasereturn: "Interest in purchasereturns",
            bool_Inventory: "Interest in inventory (stock)",
            bool_shipment: "Interest in shipments",
            bool_tracking: "Interest in updated tracking info",
            bool_salesorderpickcomplete: "Interest in the event {Sales Order Pick Complete}",
            bool_salesorderpackcomplete: "Interest in the event {Sales Order Pack Complete}",
            bool_postedinternalorders: "Interest in posted internal orders",
            bool_integratedinternalorders: "Interest in integrated internal orders",
            bool_shelfmove: "Interest in the event {Shelv Move}",
            bool_warehouseloadingorder: "Interest in newly created warehouse loading order",
            bool_itemsintegrate: "Interest in auto-integration products",
          },
          help: {
            paymentTermsHelp: "Payment terms, e.g. 30 days",
            currencyHelp: "Currency for document",


            shipToNameHelp: "Name to ship to",


            shipToName2Help: "Alternative name to ship to",


            shipToAddressHelp: "Address to ship to",


            shipToAddress2Help: "Alternative address to ship to",


            shipToMobileHelp: "Mobile for contact or SMS for shipping",


            shipToEmailHelp: "Email for contact or sending shipment info",


            shipToCountyHelp: "County to ship to",

            shipToPostCodeHelp: "Postcode to ship to",


            shipToCityHelp: "City to ship to",

            shipToCountryHelp: "Country to ship to, also used for customs settings",

            shipmentDateHelp: "Date of shipment",
            shippingAgentHelp: "This selects the shipping agent used, NShift/other integrations are connected to shipping agent",

            shippingServiceHelp: "This selects the service used, settings and JSON for creating the shipment",

            locationHelp: "Location to send products from",
            sellToCustomerHelp: "Customer to sell goods to",
            billToCustomerHelp: "Customer to bill goods to",
            quantityRequired: "Quantity is required",
            itemRequired: "Item is required",
            qtyToShipRequired: "Quantity To Ship is required",
            unitPriceRequired: "Unit Price is required",
            itemNoNoSpaces: "Item No cannot contain spaces.",
            description: "Description of item, usually used in combination with colour/sizeDescription in POS & Webshop",
            description2: "Alternative Description",
            fullDescription: "Longer item description, can include HTML and is used in the webshop’s product display",

            supplierItemNo: "The supplier's item number, can be the same but usually differs",
            primarySupplier: "Primary supplier for item",
            barcode: "Barcode for item, usually EAN13",
            salesPrice: "Primary sales price for product",
            salesPriceCurrency: "Currency for the Sales Price",
            purchasePrice: "Primary purchase price for product, used when purchasing items",
            purchasePriceCurrency: "Currency for the purchase-price",
            netWeight: "Net weight of only the goods, used in customs and shipping",
            grossWeight: "Gross weight of the total goods (incl. packaging etc), used in customs and shipping",
            volume: "Volume of package, used in customs and shipping",
            statNo: "Stat No used in customs, the number declares what the item is",
            countryOfOrigin: "Where the product is produced",
            descriptionRequired: "Description is required",
            salesPriceRequired: "Sales Price is required",
            purchasePriceRequired: "Purchase Price is required",
            nameRequired: "Name is required",
            usernameRequired: "Username is required",
            passwordRequired: "Password is required",
            usernameInfo: "This is used to login with and is your id",
            emailInfo: "User's email, used for password resets and communication.",
            passwordInfo: "Only set this if you want to change or set password. It's not shown in view for security reasons.",
            defaultLanguage: "Default Language",
            defaultCountry: "Default Country",
            itemLabelPrinter: "Printer for Item Label",
            shipmentLabelPrinter: "Printer for Shipment Label",
            addressLabelPrinter: "Printer for Address Label",
            a4Printer: "Printer for A4",
            a5Printer: "Printer for A5",
            adjustLocation: "Location to adjust",
            targetLocation: "Location to move to",
            addItemNo: "Item no to add, if no variant is chosen all the non-blocked variants get added",
            addBarcode: "Barcode of item to add to journal",
            journalDescription: "Description for the journal",
            inventoryDate: "Date to apply for the inventory journal",
            journalItemNoMultipleAddItem: "Item no to add, if no variant is chosen all the non-blocked variants get added",
            estimatedQtyRequired: "Quantity is required",
            physicalQtyRequired: "Physical Quantity is required",
            adjustmentRequired: "Adjustment is required",
            filterCustomer: "Filter for a specific customer",
            filterSupplier: "Filter for a specific supplier",
            filterLocation: "Filter for a specific location",
            filterItem: "Filter sales for a specific Item",
            connectedItemCategory: "Connected Item Category",
            optionalCodeGeneration: "Optional to set, if not set system will generate code",
            filterSalesCustomer: "Filter sales for a specific customer",
            filterSalesSupplier: "Filter sales for a specific supplier",
            filterSalesShop: "Filter sales for a specific Shop",
            filterSalesSalesperson: "Filter sales for a specific salesperson",
            filterSalesCountry: "Filter sales for a specific country",

            defaultLanguageRequired: "Default language is required",
            defaultCurrencyRequired: "Default currency is required",
            defaultCountryRequired: "Default country is required",
            defaultCurrency: "Default Currency",
            shopNameInfo: "Name of the shop",
            shopNameRequired: "Shop Name is required",
            addressExtraInfo: "Optional extra information for address, i.e. 2nd floor.",
            companyAddress: "Address of your company",
            companyName: "Name of your company",
            codeRequired: "Code is required",
            supplierName: "Name for supplier",
            supplierNameAlt: "Alternative name",
            supplierAddress: "Address for supplier",
            supplierAddressAlt: "Alternative address for supplier",
            supplierPhone: "Phone no used for contact and sms with supplier",
            supplierEmail: "Used for contact and email for supplier, i.e quote",
            supplierContact: "Extra contact for supplier",
            supplierCurrency: "Currency for supplier, this gets chosen on purchase documents",
            supplierLanguage: "Language of supplier. Used for emails and documents",
            shipToCustomer: "Customer that goods were shipped to",
            shippingAgent: "This selects the shipping agent used, NShift/other integrations are connected to shipping agent",
            shippingService: "This selects the service used, settings and JSON for creating the shipment",
            accountNoSameAsSource: "New Account No can not be the same as source",
            accountNoRequired: "Account No is required",
            accountDescriptionRequired: "Account Description is required",
            accountTypeRequired: "Account Type is required",
            postingSetupWhatRequired: "Posting setup what is required",
            unitSameAsSource: "New unit can not be the same as source",
            unitRequired: "Unit is required",
            defaultSupplierPostingGroup: "Default Supplier posting group",
            defaultSupplierPostingGroupRequired: "Default supplier posting group is required",
            primaryEmail: "Company's primary email address.",
            companyCountry: "Company's country",
            countryCodeSameAsSource: "New country code can not be the same as source",
            region: "Region of the country.",
            defaultCustomerLanguage: "Language all customers will inherit",
            defaultCustomerCurrency: "Currency all customers will inherit",
            currencyCodeRequired: "Currency Code is required",
            currencyRateRequired: "Rate is required",
            paymentProvider: "Provider/service for payments",
            paymentProviderRequired: "Payment provider is required",

            paymentProviderSetting: "Setting for provider/service for payments",
            paymentProviderSettingRequired: "Payment provider setting is required",

            cardTerminalIdRequired: "Card Terminal Id is required. Its taken from for example Adyen Terminal Id",
            salesAccount: "G/L account used for booking sales revenue",
            salesAccountRequired: "Missing Sales Account",

            salesCreditAccount: "G/L account used for booking sales credit memos",
            salesDiscountAccount: "G/L account used for booking sales discounts",

            salesVatAccount: "G/L account used for booking sales VAT",
            salesVatAccountRequired: "Missing Sales VAT Account",

            purchaseAccount: "G/L account used for booking purchases",
            purchaseCreditAccount: "G/L account used for booking purchase credit memos",
            purchaseDiscountAccount: "G/L account used for booking purchase discounts",
            purchaseReceivalAccount: "Account used to book goods received but not invoiced",
            purchaseOverheadAccount: "Account for generic purchase overheads",
            purchaseVatAccount: "Account for VAT on purchases",
            purchaseReverseVatAccount: "Account for reverse charge VAT on purchases",
            cogsAccount: "Cost of sold goods account",
            transferBalanceAccount: "Balance transfer account for movements",
            inwardGoodsAccount: "Account for receiving physical goods",
            inwardServiceAccount: "Account for receiving services",
            inwardGoodsVatAccount: "VAT account related to inward goods",
            inwardServiceVatAccount: "VAT account related to inward services",
            inventoryValueAdjustmentAccount: "Account for adjusting inventory values",
            purchaseOverheadCustomsAccount: "Customs-related overhead purchase account",
            purchaseOverheadOtherAccount: "Other overhead purchase account",
            purchaseOverheadFreightAccount: "Freight-related overhead purchase account",
            externalReference: "Used for external systems to match",
            vatPercentage: "VAT percentage applied to the transaction, e.g. 25",
            postingSetupWhat: "Posting group for items/services (the 'what' you're selling)",
            postingSetupWho: "Posting group for customers/vendors (the 'who' you're selling to)",
            salespersonCodeSame: "New Salesperson code can not be the same as source",
            posPincode: "Pincode to login to POS",
            posLanguage: "Language you want to see POS in",
            priceGroupShop: "Price group used to determine which price list is applied, e.g. 'Consumer'",
            terminalShop: "Shop for terminal",
            cardTerminal: "Which terminal the device should communicate with",
            thermalPrinter: "Printer to print receipts with",
            defaultLocationRequired: "Default Location is required.",
            defaultPriceGroupRequired: "Default Price Group is required",
            defaultPostingGroupWhoRequired: "Default Posting Group Who is required",
            defaultPostingGroupWhatRequired: "Default Posting Group What is required",
            customerRequired: "Customer is required",
            locationRequired: "Location is required.",
            targetLocationRequired: "To Location is required.",
            apiUsername: "The basic auth username for refund calls.",
            apiPassword: "The basic auth password for refund calls.",
            refundUrl: "API URL used for refund calls.",
            settlementUrl: "URL for Adyen capture or settlement endpoints.",
            apiKey: "Used for authorize and capture requests.",
            merchantAccount: "Shared across refund and settlement calls.",
            adyenPrefix: "The prefix used in your Adyen URLs, typically your account ID or organization name.",
            adyenSecret: "Secret API key used for authenticating Adyen API requests (e.g. capture, refund).",
            paypalApiUrl: "The API endpoint for PayPal requests (e.g., refunds, payments).",
            paypalApiUsername: "Your PayPal API username for authenticating requests.",
            paypalApiPassword: "Your PayPal API password used in secure API calls.",
            paypalApiSignature: "Your PayPal API signature used to verify the origin of requests.",
            fallbackKey: "Key {{index}} is used differently depending on the integration.",
            klarnaMerchantId: "The merchant ID provided by Klarna.",
            klarnaSharedSecret: "Used to sign and verify communication with Klarna.",
            klarnaBaseUrl: "The Klarna API endpoint base URL (e.g., https://api.playground.klarna.com).",
            klarnaCheckoutType: "Select whether this configuration is for Klarna Checkout (KCO) or Klarna Payments (KP).",
            klarnaTermsUrl: "Optional. Link to the merchant’s terms and conditions.",
            klarnaConfirmationUrl: "Optional. The URL Klarna should redirect the customer to after the purchase is complete.",
            klarnaCheckoutUrl1: "Optional. URL for Klarna's checkout initiation.",
            klarnaCheckoutUrl2: "Optional. Second checkout-related URL. Used if multiple stages are needed.",
            balanceAccount: "This is the account the payment is booked against, used to balance sales transactions.",
            customerName: "The customer's name, used to address and identify the recipient",
            customerNameAlt: "An alternate name for the customer, if applicable (e.g. c/o or company name)",
            customerAddress: "Primary address for delivery and correspondence",
            customerAddressAlt: "Alternate address if delivery should go to a different location than the main address",
            customerCountry: "The country where the customer is based",
            customerPhone: "Customer's phone number, used for contact and notifications",
            customerEvents: "Used to send notify customer about events in the system",
            invalidFile: "File is missing or is invalid",
            salesPriceImportDescription: "Upload a CSV file to validate and import sales prices.",
            noImportLines: "No import lines available yet.",
            importCompleteMessage: "Import finished. You can review the results above.",
            importRowHasErrors: "This row contains one or more errors",
            downloadExcel: "Download Excel",
            quantityHigherThanReturnable: "Quantity can not be higher than returnable qty",
            openPayments: "Open Payments",
            amountRequired: "Amount is required",
            invalidQuantity: "Invalid Quantity",
            quantityExceedsReturnable: "Only {{max}} can be returned; the rest will be ignored.",
            suggestAiLabelHelp: "Enter a request for what you want AI to generate. For example: 'Make me a template for an item label with itemNo, barcode, price and currency'.",
            suggestAiJsonHelp: "Describe how you want the shipping JSON configuration to change. Mention important variables or values to include.",
            labelJournalAdvancedPrices: "Set Pricegroup and curency if you want more than one price on a label",

            countryRequired: "Country is required",
            suggestItemHelp: "Enter a request for what you want ai to generate. It will use current item as base.",
            updateExisting: "Decies if AI updates current item or creates a new item.",
            defaultEmail: "Default email",
            emailSenderAddress: "Email used for sending outgoing mails",
            custServiceEmail: "Email used for customer service",
            custServicePhone: "Phone used for customer service",
            templateCustomer: "Template Customer where settings are copied from on new purchases and customers",
            templateCustomerRequired: "Template Customer is required",
            dimension1: "Dimension often used to indicate where a sales is made, e.g. a specific department or store-type",
            defaultIntegrationFlavour: "Default creates an integration shell where you can set your own keys/settings for the integration",
            qliroUrl: "The Uri provided by qliro for the integration.",
            qliroMerchantApiKey: "Your Qliro Merchant Api Key, provided by Qliro.",
            qliroSecret: "Your Qliro Secret, provided by Qliro.",
            defaultPriceGroup: "Default Price group used in bex, can be overriden by customers",
            defaultPostingGroupWho: "Default Posting Group Who used in bex, can be overriden by customers",
            defaultCustomerPostingGroup: "Default Customer Posting Group used in bex, can be overriden by customers",
          },
          dialog: {
            lineSaved: "Line saved successfully!",
            lineSaveError: "Error in saving line",
            deleteRowConfirm: "Are you sure you want to delete this row?",
            rowDeleted: "Successfully deleted row",
            rowDeleteError: "Error in deleting row",
            allRowsDeleted: "Successfully deleted all rows",
            saveBeforeLines: "Please save document before editing lines",
            selectVariant: "Can't add item if it has variants, select a variant.",
            rowsDeleteError: "Error in deleting rows",
            paymentSaved: "Payment saved successfully",
            failedToSaveChanges: "Failed to save changes",
            paymentDeleted: "Payment deleted successfully",
            paymentDeleteError: "Failed to delete payment",
            mobileRequired: "Please set the mobile number on the document before proceeding.",
            paymentInitError: "Error initiating payment",
            paymentSuccess: "Payment Successful",
            paymentDenied: "Payment Denied",
            awaitingConfirmation: "Awaiting Confirmation",
            statusFetchError: "Error fetching status",
            statusUnknown: "Payment status unknown",
            paymentFetchError: "Failed to fetch updated payment",
            paymentInitialized: "Payment initialized",
            itemNotFoundWithDefault: "No item found for itemNo: {{no}}. Initializing with default values.",
            itemFetchError: "Failed to fetch item",
            settingNewItem: "setting new Item",
            fixErrors: "Please fix the following errors:",
            itemSaved: "Item saved successfully!",
            variantsSaved: "All variants saved successfully",
            itemCopied: "Item copied successfully!",
            deleteItemConfirm: "Are you sure you want to delete this item?",
            itemDeleted: "Item deleted successfully!",
            itemDeleteError: "Failed to delete Item",
            imageUploaded: "Image uploaded successfully!",
            imageUploadError: "Failed to upload the image. Please try again.",
            fileUploadError: "Failed to upload file. Please try again",
            cannotCopyPreliminaryItem: "Can not copy preliminary item, save first",
            editItem: "Edit Item",
            createNewItem: "Create New Item",
            enterValidDescription: "Please enter a valid description",
            optionExists: "This option already exists.",
            savedSuccessfully: "Saved successfully",
            saveErrorGeneric: "Error while saving. Please try again.",

            variantSaved: "Variant saved successfully",
            variantSaveError: "Error saving variant",

            variantAddNoSelection: "Failed to add variant. No variant selected.",
            variantAddColorMissing: "Failed to add variant. Colour code is required.",
            variantAddSizeMissing: "Failed to add variant. Size code is required.",
            variantAddLengthMissing: "Failed to add variant. Length code is required.",

            variantRemoved: "Variant removed",
            variantDeleted: "Variant deleted successfully",
            variantDeleteError: "Failed to delete variant",
            failedToFetchData: "Failed to fetch data",
            failedDelete: "Failed to delete",
            navigateToGroupConfirm: "Are you sure you want to navigate to {{groupName}}?",
            userMissing: "User data is missing.",
            nameRequired: "Name is required.",
            usernameRequired: "Username is required.",
            emailRequired: "Email is required.",
            passwordRequired: "Password is required.",
            cannotCopyPreliminary: "Can not copy preliminary, save first",
            usernameSameAsSource: "New username can not be the same as source",
            userCopied: "User copied successfully!",
            deleteEntityConfirm: "Are you sure you want to delete this item?",
            userDeleted: "User deleted successfully!",
            journalCreateError: "Failed to create journal",
            inventoryMissing: "Inventory data is missing.",
            locationRequired: "Location is required.",
            saveBeforeContinuing: "Save the bonus system before continuing",
            valueRequired: "Value is required",
            noItemOrBarcode: "No item or barcode chosen, can't add",
            addingItems: "Adding Item(s)",
            addLineError: "Failed to add line",
            confirmDeleteAllLines: "Are you sure you want to delete all lines?",
            fetchLinesError: "Error in fetching lines",
            deletedSuccessfully: "Deleted successfully",
            deleteFailed: "Failed to delete.",
            descriptionRequired: "Missing Description is required.",
            itemCategoryRequired: "Missing Item Category is required.",
            fetchStatusError: "Error fetching status",
            graphEmpty: "Graph is now empty",
            graphRemoveItem: "Removed",
            graphAddItem: "Added",
            downloadSuccess: "Successfully downloaded document!",
            fetchServiceJsonError: "Failed to fetch service jsons",
            companySetupSuccess: "Successfully setup company and shop.",
            companyDataMissing: "Company data is missing.",
            companyNameRequired: "Company Name is required.",
            companyCurrencyRequired: "Company Currency is required.",
            companyLanguageRequired: "Company Language is required.",
            shopDataMissing: "Shop data is missing.",
            shopNameRequired: "Shop Name is required.",
            createJournalError: "Failed to create journal",
            fetchSupplierError: "Failed to fetch supplier",
            invalidRequest: "Invalid login request.",
            accountLocked: "Account is locked due to too many failed attempts.",
            invalidCredentials: "Invalid username or password.",
            accountDataMissing: "Account data is missing.",
            accountNoRequired: "Account No is required.",
            accountDescriptionRequired: "Description is required.",
            accountTypeRequired: "Account Type is required.",
            copyPreliminaryAccount: "Can not copy preliminary account, save first",
            accountNoSameAsSource: "New AccountNo can not be the same as source",
            accountCopiedSuccess: "Account copied successfully!",
            accountCopyError: "Failed to copy account",
            accountNoEmpty: "Account No cannot be empty",
            accountDescriptionEmpty: "Description cannot be empty",
            fetchCompanyError: "Failed to fetch company",
            unitRequired: "Unit is required.",
            currencyRequired: "Currency is required.",
            languageRequired: "Language is required.",
            priceGroupRequired: "Pricegroup is required.",
            postingGroupWhoRequired: "Postinggroup, who is required.",
            customerPostingGroupRequired: "Customer posting group is required.",
            supplierPostingGroupRequired: "Supplier posting group is required.",
            copyPreliminaryCompany: "Can not copy preliminary company, save first",
            unitSameAsSource: "New unit can not be the same as source",
            copySuccess: "Entity copied successfully!",
            copyError: "Failed to copy entity",
            unitEmpty: "Unit cannot be empty",
            copyPreliminaryCountry: "Can not copy preliminary country, save first",
            countryCodeSameAsSource: "New country code can not be the same as source",
            dataMissing: "Data is missing.",
            codeEmpty: "Code cannot be empty",
            currencyCodeRequired: "Currency Code is required.",
            currencyDescriptionRequired: "Description is required.",
            currencyRateRequired: "Rate is required.",
            copyPreliminaryLocation: "Can not copy preliminary location, save first",
            postingGroupWhatOrWhoRequired: "Posting setup what or posting setup who is required",
            salesAccountMissing: "Missing sales account",
            salesVatAccountMissing: "Missing sales VAT Account",
            activatePrintNodeFailed: "Failed to activate Print Node",
            salespersonCopyPreliminary: "Can not copy preliminary salesperson, save first",
            salespersonCodeSame: "New salesperson code can not be the same as source",
            salespersonCopied: "Salesperson copied successfully!",
            salespersonCopyFailed: "Failed to copy salesperson",
            enterNewCode: "Enter a New Code",
            copyPreliminaryEntity: "Can not copy preliminary entity, save first",
            entityCopied: "Copied successfully!",
            copyFailed: "Failed to copy",
            codeRequired: "Code cannot be empty",
            fixJsonBeforeSave: "Fix JSON errors before saving.",
            invalidJsonReset: "Invalid JSON format received. Resetting to empty.",
            sectionAdded: "Section added.",
            sectionAlreadyExists: "Section already exists.",
            invalidJsonBeforeSave: "Invalid JSON format. Fix errors before saving.",
            shopRequired: "Shop is required.",
            refundIncomplete: "Please fill in all refund fields if you wish to configure it.",
            settlingIncomplete: "Please fill in all settlement fields, including Merchant Account.",
            balanceAccountRequired: "Balance Account Required",
            missingLocation: "Missing Location",
            successCreatedReturn: "Return was created successfully.",
            failedToCreateReturn: "Failed to create return.",
            invalidReturn: "Invalid Return, please choose items to return first",
            missingFilters: "Missing Filters",
            areYouSure: "Are you sure?",
            customerAnonymizedQueued: "Customer is queued to be anonymized, will be ran after 00:00 (midnight)",
            selectItem: "Select Item",
            selectAccount: "Select Account",
            fortNoxReAuthError: "Fortnox needs re-authorization. Please reinstall.",
            fortNoxAccountInactive: "An account send to Fortnox is inactive and therefore the integration has stopped, please activate the account under (kontoplan) in fortnox, see more info in systemlog",
            fortNoxAccountMissing: "An account sent to Fortnox is missing, please check the account under (kontoplan) in fortnox, see more info in systemlog",
            fortnoxInstallMessage: "Clicking install will redirect you to Fortnox where you sign in and install the application. When you return, we configure the integration and it starts automatically.",
            fortnoxInstallSuccess: "Fortnox integration installed successfully.",
            fetchDataError: "Failed to fetch data",
            itemImportSuccess: "Item import successful",
            importSuccessText: "Import was successful, all lines were succesfully imported",
            importSuccessFlavor: "You can now review your items or return to the list to continue working.",
            importGoToList: "Go to item list",
            importStay: "Stay",
            cannotChangeCompletedLine: "Can not change completed line",
            noLinesToHandle: "No lines to handle",
            actionSuccess: "Action was executed successfully",
            missingCustomer: "Missing Customer",
            queuedForPrint: "Queued for print",
            missingPrompt: "Missing work description for ai",
            doYouWishToCreateALabelJournal: "Do you wish to create a label journal for this receival?",
            chooseIntegrationType: "Choose Integration Type",
            requiredFields:"Required Fields",

          },
          actions: {
            addItem: "Add Item",
            addAccount: "Add Account",
            addCertificate: "Add Certificate",
            addText: "Add Text",
            deleteAll: "Delete All",
            addPayment: "Add Payment",
            payByLink: "Pay by Link",
            addToReturn: "Add to Return",
          },
          graph: {
            orderGraphTitle: "Orders Over Time",
            orderGraphSummaryTitle: "Analysis",
            orderGraphDescription: "This graph shows the number of orders placed per day over the selected time range. It helps identify order trends, seasonal peaks, and the impact of promotions or campaigns.",
            orderExtraInfo: "The data is updated daily from the order system and includes all order sources such as web, point of sale, and manual registrations. Holidays and weekends may cause natural fluctuations in volume.",


            itemGraphTitle: "Top 10 Items",

            itemGraphSummaryTitle: "Insight",
            itemGraphDescription: "This chart displays the top 10 best-selling items during the selected period, sorted by total quantity sold. It's useful for analyzing product performance and identifying high-demand inventory.",
            itemExtraInfo: "Includes all active sales channels and order types. Items with the same name are grouped. The data reflects finalized transactions only.",
            programGraphTitle: "Sales by Program",
            programGraphSummaryTitle: "Programs",
            programGraphDescription: "Highlights revenue per program for the chosen period.",
            programExtraInfo: "Only completed transactions contribute to these totals.",
            countryGraphTitle: "Sales by Country",
            countryGraphSummaryTitle: "Distribution",
            countryGraphDescription: "Shows sales amounts by customer country for the selected period.",
            countryExtraInfo: "Uses billing country from sales documents. Only finalized transactions are included.",
            shopAvgGraphTitle: "Sales Qty Avg per Shop",
            shopAvgValueGraphTitle: "Sales Amount Avg per Shop",
            shopReturnFreqGraphTitle: "Return Frequency per Shop",
            productGroupGraphTitle: "Sales by Product Group",
            itemCategoryGraphTitle: "Sales by Item Category",
            itemGroupGraphTitle: "Sales by Item Group",
            dimensionGraphTitle: "Sales by Dimension",
          },
          graphBuilder: {
            title: "Customize Dashboard",
            save: "Save",
            editDashboard: "Edit Dashboard"
          }
        }
      },
      sv: {
        translation: {
          pageLanding: {
            welcome: "Välkommen till Mini Backoffice",
            // ...
          },
          common: {
            sales: "Försäljning",
            purchase: "Inköp",
            inventory: "Lager",
            history: "Historik",
            order: "Order",
            invoice: "Faktura",
            credit: "Kredit",
            shipment: "Leverans",
            customers: "Kunder",
            item: "Artikel",
            items: "Artiklar",
            itemLabels: "Artikel-etiketter",
            open: "Öppna",
            created: "Skapad",
            copies: "Kopior",
            templates: "Mallar",
            template: "Mall",
            number: "Nummer",
            print: "Skriv ut",
            price: "Pris",
            pricelist: "Prislista",
            salesPriceImport: "Import av försäljningspriser",
            originalPrice: "Originalpris",
            priceGroupA: "Prisgrupp A",
            priceGroupB: "Prisgrupp B",
            currenciesA: "Valutor A",
            currenciesB: "Valutor B",
            includeVat: "Inkludera moms",
            shelf: "Hylla",
            colour: "Färg",
            size: "Storlek",
            length: "Längd",
            add: "Lägg till",
            added: "Tillagt",
            changesSaved: "Ändringar sparade",
            selectTemplate: "Välj mall",
            printQueued: "Utskrift köad",
            fetchDataError: "Misslyckades med att hämta data",
            createError: "Misslyckades med att skapa",
            saveError: "Misslyckades med att spara",
            addError: "Misslyckades med att lägga till",
            deleteError: "Misslyckades med att ta bort",
            printError: "Misslyckades med att skriva ut",
            locationRequired: "Plats krävs",
            copiesCleared: "Kopior nollställda",
            operationFailed: "Åtgärden misslyckades",
            missingDocument: "Saknar dokument",
            chooseFile: "Välj fil",
            validate: "Validera",
            addLines: "Lägg till rader",
            addFromInventory: "Lägg till från lager",
            clearCopies: "Nollställ kopior",
            removeAllLines: "Ta bort alla rader",
            noData: "Inga data",
            notSet: "Inte angivet",
            header: "Huvud",
            initCode: "Init-kod",
            externalValue1: "Extra externt värde 1",
            partition: "Unifaun-partitionsnamn",
            favorite: "Unifaun utskriftsfavoritnamn",
            dateTime: "Datum och tid för etikettens skapande",
            supplier: "Leverantör",
            suppliers: "Leverantörer",
            integration: "Integration",
            integrations: "Integrationer",
            orders: "Ordrar",
            batches: "Batchar",
            bonusBatch: "Bonuskörning",
            bonusSystem: "Bonussystem",
            bonusGroup: "Bonusgrupp",
            bonusPoints: "Bonuspoäng",
            bonusLadder: "Bonustrappa",
            bonusRate: "Bonuskurs",
            calculationInterval: "Beräkningsintervall",
            continuous: "Kontinuerlig",
            period: "Periodvis",
            validDays: "Giltighetsdagar",
            reservationAccount: "Reserveringskonto",
            reservedVatAccount: "Reserverat moms-konto",
            debtAccount: "Skuldkonto",
            givesBonusAmount: "Ger bonusbelopp",
            bonusPointExchangeRate: "Bonuspoäng växelkurs",
            calculateFromPreliminary: "Beräkna från preliminära transaktioner",
            runBatch: "Kör batch",
            selectBatch: "Välj en batch för att se resultat",
            lines: "Rader",
            importLines: "Importrader",
            onlyErrors: "Endast fel",
            settings: "Inställningar",
            itemDimensions: "Artikeldimensioner",

            colourGroup: "Färggrupp",
            sizeGroup: "Storleksgrupp",
            lengthGroup: "Längdgrupp",
            itemGroup: "Varugrupp",
            itemCategory: "Artikelkategori",
            productGroup: "Produktgrupp",
            program: "Program",
            collection: "Kollektion",
            statNo: "Stat Nr.",
            transactions: "Transaktioner",
            invAdjustment: "Lagerjustering",
            // settings
            general: "Allmänt",
            company: "Företag",
            country: "Land",
            countryCode: "Landskod",
            currency: "Valuta",
            language: "Språk",
            languageCulture: "Språk-kultur",
            businessSettings: "Affärsinställningar",
            account: "Konto",
            paymentTerminal: "Betalterminal",
            postingSetup: "Bokföringsinställningar",
            salesperson: "Säljare",
            shop: "Butik",
            terminal: "Terminal",
            warehouse: "Lager",
            location: "Lagerställe",
            printer: "Skrivare",
            shippingAgent: "Fraktare",
            administration: "Administration",
            metrics: "Mätvärden",
            users: "Användare",
            username: "Användarnamn",
            password: "Lösenord",
            login: "Logga in",
            logout: "Logga ut",
            value: "Värde",
            qty: "Antal",
            summary: "Sammanställning",
            select: "Välj",
            from: "Från",
            to: "Till",
            status: "Status",
            processed: "Klar",
            unprocessed: "Ej körd",
            pending: "Pågående",
            finance: "Ekonomi",
            create: "Skapa",
            search: "Sök",
            searchOrders: "Sök order",
            fetchMore: "Hämta fler",
            clear: "Rensa",
            results: "Resultat",
            identifier: "Identifierare",
            priority: "Prioritet",
            keyword: "Nyckelord",
            type: "Typ",
            url: "URL",
            icon: "Ikon",
            customerNo: "Kundnummer",
            customerContact: "Leverera till - Kontaktperson",
            customerFax: "Kundens faxnummer",
            customerOrgNo: "Kundens organisationsnummer",
            customerDoorcode: "Leverera till - Portkod",
            customerEmail: "Kundens e-postadress",
            customerSms: "Leverera till - Mobilnummer",
            customerVatNo: "Kundens momsregistreringsnummer",
            name: "Namn",
            name2: "Namn2",
            address: "Adress",
            address2: "Adress2",
            noOrdersFound: "Inga order hittades",
            noOrderInBatch: "Ingen order hittades för plock/pack, lägg till order i batchen.",
            previous: "Föregående",
            next: "Nästa",
            view: "Visa",
            pageOf: "Sida {{current}}/{{total}}",
            failedToCreateOrder: "Misslyckades med att skapa order",
            failedToFetchOrders: "Misslyckades med att hämta order",
            documentSaved: "Dokument sparades!",
            unsavedChanges: "Du har osparade ändringar",
            failedToSaveDocument: "Misslyckades med att spara dokument",
            failedToFetchSettings: "Misslyckades med att hämta uppdaterade inställningar",
            failedToPost: "Misslyckades med att skicka",
            failedToCancel: "Misslyckades med att avbryta",
            failedToCopy: "Misslyckades med att kopiera",
            failedToPrint: "Misslyckades med att skriva ut",
            failedToSendEmail: "Misslyckades med att skicka e-post",
            failedToIntegrate: "Misslyckades med att integrera",

            orderNo: "Ordernummer",
            orderBatchNo: "Orderbatch-ID för källdokument",
            orderAmount: "Postförskottsbelopp",
            sellToCustomerNo: "Beställare - Kundnr",
            billToCustomerNo: "Faktureras till - Kundnr",
            showCustomerInfo: "Visa kundinformation",
            sellToCustomerName: "Beställare - Kundnamn",
            billToCustomerName: "Faktureras till - Kundnamn",
            sellToCustomerName2: "Beställare - Kundnamn 2",
            billToCustomerName2: "Faktureras till - Kundnamn 2",
            sellToCustomerAddress: "Beställare - Adress",
            billToCustomerAddress: "Faktureras till - Adress",
            sellToCustomerAddress2: "Beställare - Adress 2",
            billToCustomerAddress2: "Faktureras till - Adress 2",
            sellToCustomerPostCode: "Beställare - Postnummer",
            billToCustomerPostCode: "Faktureras till - Postnummer",
            sellToCustomerCity: "Beställare - Stad",
            billToCustomerCity: "Faktureras till - Stad",
            sellToCustomerContact: "Beställare - Kontaktperson",
            billToCustomerContact: "Faktureras till - Kontaktperson",
            sellToCustomerMobile: "Beställare - Mobil",
            billToCustomerMobile: "Faktureras till - Mobil",
            sellToCustomerEmail: "Beställare - E-post",
            billToCustomerEmail: "Faktureras till - E-post",
            sellToCountry: "Beställare - Land",
            billToCountry: "Faktureras till - Land",
            selltoCustomerNo: "Beställare Kundnr",
            selltoCustomerName: "Beställare Kundnamn",
            selltoAddress: "Beställare Adress",
            selltoPostCode: "Beställare Postnummer",
            selltoCity: "Beställare Stad",
            selltoCounty: "Beställare Region",
            paymentTerms: "Betalningsvillkor",


            orderDate: "Orderdatum",
            showShippingInfo: "Visa leveransinformation",

            shipToName: "Leverera till - Namn",


            shipToName2: "Leverera till - Namn 2",


            shipToAddress: "Leverera till - Adress",


            shipToAddress2: "Leverera till - Adress 2",


            shipToMobile: "Leverera till - Mobilnummer",

            shipToEmail: "Leverera till - E-post",


            shipToCounty: "Leverera till - Region",


            shipToPostCode: "Leverera till - Postnummer",


            shipToCity: "Leverera till - Stad",


            shipToCountry: "Leverera till - Land",
            shipToCustomerName: "Leverera till - Namn",
            shipToCustomerName2: "Leverera till - Namn 2",
            shipToCustomerAddress: "Leverera till - Adress",
            shipToCustomerAddress2: "Leverera till - Adress 2",
            shipToCustomerPostCode: "Leverera till - Postnummer",
            shipToCustomerCity: "Leverera till - Stad",
            shipToCustomerCounty: "Leverera till - Region",
            shipToCustomerCountryCode: "Leverera till - Landskod",


            emailShipment: "Skicka leveransinformation via e-post",

            shipmentDate: "Leveransdatum",
            parcelGrossWeight: "Paket - Bruttovikt",
            parcelVolume: "Paket - Volym",
            parcelLength: "Paket - Längd",
            parcelWidth: "Paket - Bredd",
            parcelHeight: "Paket - Höjd",
            parcelContents: "Paket - Innehåll",
            parcelPackageCode: "Paket - Paketkod",

            shippingService: "Frakttjänst",


            showPayments: "Visa betalningar",
            paymentMethod: "Betalningsmetod",
            amount: "Belopp",
            payments: "Betalningar",
            post: "Bokför",
            cancel: "Avbryt",
            cancel_mak: "Makulera",
            copy: "Kopiera",
            delete: "Ta bort",
            anonymizePersonalData: "Anonymisera kund (GDPR)",
            sendEmail: "Skicka e-post",
            integrate: "Integrera",
            integrated: "Integrerade",
            integrateTa: "Integrera TA",
            edit: "Redigera",
            noImage: "Ingen bild tillgänglig",
            barcode: "Streckkod",
            unitPrice: "Styckpris",
            discount: "Rabatt",
            editLine: "Redigera rad",
            itemNo: "Artikelnummer",
            accountNo: "Kontonummer",
            certificateAccount: "Värdebeviskonto",
            description: "Beskrivning",
            quantity: "Antal",
            qtyToShip: "Antal att leverera",
            lineDiscount: "Radrabatt",
            save: "Spara",
            certificateCode: "Värdebeviskod",
            actions: "Actions",
            mobileNumber: "Mobilnummer",
            initiate: "Initiera",
            showCertificates: "Visa värdebevis",
            createPayment: "Skapa betalning",
            editPayment: "Redigera betalning",
            searchItems: "Sök artiklar",
            noItemsFound: "Inga artiklar hittades",
            uploadImage: "Ladda upp bild",
            description2: "Beskrivning 2",
            supplierItemNo: "Leverantörens artikelnummer",
            salesPrice: "Försäljningspris",
            salesPriceCurrency: "Valuta för försäljningspris",
            purchasePrice: "Inköpspris",
            purchasePriceCurrency: "Valuta för inköpspris",
            showCustoms: "Visa tullinformation",
            netWeight: "Nettovikt",
            grossWeight: "Bruttovikt",
            volume: "Volym",
            countryOfOrigin: "Ursprungsland",
            blocked: "Blockerad",
            salesBlocked: "Säljblockerad",
            manageVariants: "Hantera varianter",
            close: "Stäng",
            back: "Tillbaka",
            saving: "Sparar...",
            itemInfo: "Artikelinfo",
            pricing: "Prissättning",
            variantGroups: "Variantgrupper",
            variants: "Varianter",

            addSplitLine: "Returnera en till artikel",
            cancelWizard: "Avbryt guide",
            finish: "Slutför",
            variant: "Variant",
            editVariant: "Redigera variant",
            page: "Sida",
            deleted: "Borttagen",
            yes: "Ja",
            no: "Nej",
            noEntriesFound: "Ingen data hittades",
            enterNewUser: "Lägg till ny användare",
            newUsername: "Nytt användarnamn",
            newPassword: "Nytt lösenord",
            editUser: "Redigera användare",
            email: "E-post",

            admin: "Admin",
            itemLabelPrinter: "Etikettskrivare för artikel",
            printers: "Skrivare",
            shipmentLabelPrinter: "Etikettskrivare för leverans",
            addressLabelPrinter: "Etikettskrivare för adress",
            a4Printer: "A4-skrivare",
            a5Printer: "A5-skrivare",
            selectJournalType: "Välj typ av journal",
            stockTaking: "Inventering",
            adjustment: "Justering",
            receival: "Inleverans",
            journalTypeDescriptions: {
              Adjustment: "Justering",
              TransferIn: "Transfer in",
              TransferOut: "Transfer ut",
              Purchase: "Inleverans",
              Stocktaking: "Inventering",
              Invoice: "Faktura",
              Credit: "Kreditfaktura",
              Revaluation: "Värdering",
              RevaluationCurrency: "Värdering (Valuta)",
              RevaluationValue: "Värdering (Värde)",
              ShelfMove: "Flytt på hylla",
            },
            editJournal: "Redigera journal",
            journal: "Journal",
            loadingdotdot: "laddar...",
            selectPostingMode: "Välj bokföringsläge",
            postIncluded: "Bokför endast inkluderade artiklar",
            includeAndZero: "Inkludera och nollställ ej skannade artiklar",
            documentNo: "Dokumentnummer",
            addItems: "Lägg till artiklar",
            showAdvancedSettings: "Visa avancerade inställningar",
            inventoryDate: "Lagerdatum",
            searchForItem: "Sök efter artikel",
            toggleListMode: "Växla listläge",
            cancelFocus: "Avbryt fokus",
            estimatedQty: "Uppskattad kvantitet",
            physicalQty: "Fysisk kvantitet",
            costAmount: "Kostnadsbelopp",
            saveChanges: "Spara ändringar",
            deleteAll: "Ta bort alla",
            customer: "Kund",
            postingDate: "Bokföringsdatum",
            advancedFilter: "Avancerat filter",
            fetch: "Hämta",
            addProductGroupSetting: "Lägg till produktgruppsinställning",
            setting: "Inställning",
            dateFrom: "Från datum",
            dateTo: "Till datum",
            generateReport: "Generera rapport",
            salesDistribution: "Försäljningsfördelning",
            itemReport: "Artikelrapport",
            totalSum: "Totalt belopp",
            removeFromGraph: "Ta bort från diagram",
            addToGraph: "Lägg till i diagram",
            amountIncVat: "Belopp inkl. moms",
            cbMargin: "TB",
            cbPercent: "TB %",
            openShippingForm: "Öppna fraktsedel",
            openReturnForm: "Öppna retursedel",
            openShippingLabel: "Öppna fraktetikett",
            openReturnLabel: "Öppna returetikett",
            openInPack: "Öppna i pack",
            openBatch: "Öppna batch",
            openPick: "Öppna plock",
            openPack: "Öppna pack",
            openNextOrder: "Öppna nästa order",
            addOrderToBatch: "Lägg till order",
            orderAddedToBatch: "Order tillagd i batchen",
            confirmAddOrder: "Lägg till order {{orderNo}} i batch {{batchId}}?",
            basket: "Korg",
            printShippingLabel: "Skriv ut fraktetikett",
            printReturnLabel: "Skriv ut returetikett",

            contents: "Innehåll",
            width: "Bredd",
            height: "Höjd",
            packageType: "Pakettyp",
            tracking: "Spårning",
            parcelCode: "Paketkod",
            setupInitialCompany: "Initial företagsuppsättning",
            postCode: "Postnummer",
            city: "Stad",
            defaultLanguage: "Standardspråk",
            defaultCurrency: "Standardvaluta",
            defaultCountry: "Standard land",
            baseColour: "Basfärg",
            editColour: "Redigera färg",
            editColourGroup: "Redigera färggrupp",
            base: "Bas",
            editLengthGroup: "Redigera längdgrupp",
            editSizeGroup: "Redigera storleksgrupp",
            none: "Ingen",
            itemLedger: "Lagertransaktioner",
            remainingQuantity: "Återstående kvantitet",
            shipmentMethod: "Fraktsätt",
            shipmentNo: "Fraktnummer",
            shipToCustomer: "Skicka till kund",
            showParcels: "Visa paket",
            contact: "Kontakt",
            invoiceDiscountGroup: "Fakturarabattsgrupp",
            postingSetupWho: "Bokföringsinställning Vem",
            invoices: "Fakturor",
            credits: "Krediteringar",
            setupSuccessTitle: "Grattis till en lyckad installation!",
            setupSuccessText: "Allt är klart 🎉 Du kan nu om du vill:",
            createItem: "Skapa en artikel",
            createFirstOrder: "Skapa din första order",
            runSalesReport: "Kör försäljningsrapport",
            goToStart: "Gå till Start",
            failedToFetchEntries: "Misslyckades med att hämta data",
            newAccountNo: "Nytt kontonummer",
            newAccountDescription: "Ny kontobeskrivning",
            accountType: "Kontotyp",
            postingSetupWhat: "Bokföringsinställning Vad",
            showSettings: "Visa inställningar",
            showTransactions: "Visa transaktioner",
            locked: "Låst",
            handled: "Hanterad",
            notified: "Notifierad",
            vatDeclarationCode: "Momsdeklarationskod",
            ossType: "OSS-typ",
            sru: "SRU",
            companies: "Företag",
            unit: "Enhet",
            enterNewUnit: "Ange en ny enhet",
            newUnit: "Ny enhet",
            customerPostingGroup: "Kundens bokföringsgrupp",
            supplierPostingGroup: "Leverantörens bokföringsgrupp",
            testCompany: "Testföretag",
            showContactSettings: "Visa kontaktinställningar",
            seat: "Säte",
            customerServicePhone: "Kundtjänst Telefon",
            customerServiceEmail: "Kundtjänst E-post",
            senderEmail: "Avsändarens E-post",
            website: "Webbplats",
            showFinanceSettings: "Visa finansinställningar",
            orgNo: "Org.nr",
            vatNo: "Momsnr",
            code: "Kod",
            newCode: "Ny kod",
            confirm: "Bekräfta",
            region: "Region",
            templateCustomerB2C: "Mallkund - B2C",
            callingCode: "Landskod (Telefon)",
            createOcr: "Skapa OCR",
            customsInvoice: "Tullfaktura",
            createReturnDocument: "Skapa returdokument",
            currencyCode: "Valutakod",
            customsCurrencyUnit: "Valutakod",
            symbol: "Symbol",
            rate: "Kurs",
            validFrom: "Giltig från",
            currencyAccount: "Valutakonto",
            roundingPos: "Avrundning POS",
            decimalScale: "Decimaler",
            locations: "Lagerställen",
            showAccounts: "Visa konton",
            inventoryAccount: "Lagerkonto",
            transferBalanceAccount: "Överföringssaldo konto",
            default: "Standard",
            consumer: "Konsument",
            business: "Företag",
            paymentTerminals: "Betalterminaler",
            paymentProvider: "Betalleverantör",
            paymentProviderSetting: "Betalleverantörsinställning",
            cardTerminalId: "Terminal-Id",
            startDate: "Startdatum",
            endDate: "Slutdatum",
            vatPercentage: "Moms %",
            vatType: "Momstyp",
            salesAccount: "Försäljningskonto",
            salesCreditAccount: "Försäljningskreditkonto",
            salesDiscountAccount: "Försäljningsrabattkonto",
            salesVatAccount: "Momsförsäljningskonto",
            showMoreSettings: "Visa fler inställningar",
            purchaseAccount: "Inköpskonto",
            purchaseCreditAccount: "Inköpskreditkonto",
            purchaseDiscountAccount: "Inköpsrabattkonto",
            purchaseReceivalAccount: "Mottagningskonto för inköp",
            purchaseOverheadAccount: "Inköpsomkostnadskonto",
            purchaseVatAccount: "Momsinköpskonto",
            purchaseReverseVatAccount: "Omvänd moms inköpskonto",
            cogsAccount: "Kostnad sålda varor",
            inwardGoodsAccount: "Inleverans varor konto",
            inwardServiceAccount: "Inleverans tjänst konto",
            inwardGoodsVatAccount: "Momskonto inleverans varor",
            inwardServiceVatAccount: "Momskonto inleverans tjänster",
            inventoryValueAdjustmentAccount: "Lagerjustering konto",
            purchaseOverheadCustomsAccount: "Inköpsomkostnad Tullkonto",
            purchaseOverheadOtherAccount: "Inköpsomkostnad Övrigt konto",
            purchaseOverheadFreightAccount: "Inköpsomkostnad Fraktkonto",
            externalReference: "Extern referens",
            result: "Resultat",
            balance: "Balans",
            apiKey: "API Nyckel",
            activatePrintNode: "Aktivera PrintNode",
            administrator: "Administratör",
            showPermissions: "Visa Behörigheter",
            allowDiscount: "Tillåt Rabatt",
            allowPriceChange: "Tillåt Prisändring",
            allowCashWithdrawal: "Tillåt Uttag",
            services: "Tjänster",
            returnLink: "Returlänk",
            clickAndCollect: "Click and Collect",
            showReturnSettings: "Visa Returinställningar",
            returnName: "Retur Namn",
            returnName2: "Retur Namn 2",
            returnAddress: "Returadress",
            returnAddress2: "Returadress 2",
            returnPostcode: "Retur Postnummer",
            returnCity: "Retur Stad",
            returnCounty: "Retur Län",
            returnCountry: "Retur Land",
            showIntegrationSettings: "Visa Integrationsinställningar",
            connectedSystem: "Kopplat System",
            integrationEndpoint: "Integration EndPoint",
            integrationUsername: "Integration Användarnamn",
            integrationPassword: "Integration Lösenord",
            entityCodeSame: "Ny kod kan inte vara samma som källan",
            returnAsNormalShipment: "Retur som vanlig försändelse",
            showFreightDimensions: "Visa fraktmåttsinställningar",
            standardWeight: "Standardvikt",

            minWeight: "Min vikt",
            maxWeight: "Max vikt",
            maxLength: "Max längd",
            maxVolume: "Max volym",
            showShipmentInfo: "Visa leveransinformation",
            useShipmentAddress: "Använd leveransadress",
            editor: "Redigerare",
            addSections: "Lägg till sektioner",
            addPdfConfig: "Lägg till PdfConfig",
            addShipment: "Lägg till Leverans",
            addAgent: "Lägg till Ombud",
            addCustomsDeclaration: "Lägg till Tullblankett",
            priceGroup: "Prisgrupp",
            active: "Aktiv",
            inactive: "Inaktiv",
            terminalNo: "TerminalNr",
            cashDrawer: "Kassalåda",
            ccuId: "CCU ID",
            ccuUnit: "CCU Enhet",
            apiSecret: "API Hemlighet",
            installedOnUnit: "Installerad på enhet",
            installationDate: "Installationsdatum",
            cardTerminal: "Kortterminal",
            thermalPrinter: "Kvitto-skrivare",
            reports: "Rapporter",
            paymentProviderConfig: "Betalleverantör Config",
            apiUsername: "API-användarnamn",
            apiPassword: "API-lösenord",
            refundUrl: "Återbetalnings-URL",
            settlementUrl: "Settling-URL",
            merchantAccount: "Merchant-konto",
            refund: "Återbetalning",
            settling: "Settling",
            selectPaymentProvider: "Välj betalleverantör",
            pricesInclVat: "Priser inkl. moms",
            home: "Hem",
            paypalApiUsername: "PayPal API-användarnamn",
            paypalApiPassword: "PayPal API-lösenord",
            paypalApiSignature: "PayPal API-signatur",
            paymentProviderKey: "Betalleverantör nyckel {{index}}",
            newDescription: "Ny Beskrivning",
            enterNewDescription: "Fyll i ny beskrivning",
            enterNewAccountNo: "Fyll i nytt kontonr.",
            klarnaInfo1: "Klarna Merchant ID",
            klarnaInfo2: "Klarna Shared Secret",
            klarnaInfo3: "Klarna API-URL",
            klarnaInfo5: "Klarna-leverantörstyp",
            klarnaInfo6: "Köpvillkors-URL",
            klarnaInfo7: "Bekräftelsesida-URL",
            klarnaInfo8: "Checkout-URL",
            klarnaInfo9: "Checkout-URL (Alternativ)",
            paymentType: "Betaltyp",
            paymentType_None: "Ingen",
            paymentType_Cash: "Kontant",
            paymentType_VISA: "VISA",
            paymentType_MasterCard: "MasterCard",
            paymentType_Diners: "Diners Club",
            paymentType_AMEX: "AMEX",
            paymentType_Dankort: "Dankort",
            paymentType_CoD: "Postförskott",
            paymentType_Facturing: "Fakturering",
            paymentType_Downpayment: "Förskott",
            paymentType_Giftcard: "Presentkort",
            paymentType_Creditnote: "Kreditnota",
            paymentType_Maestro: "Maestro",
            paymentType_BABS: "BABS",
            paymentType_CHECK: "Check",
            paymentType_Invoice: "Faktura",
            paymentType_Credit: "Kredit",
            paymentType_BankTransfer: "Banköverföring",
            paymentType_RIKSGiftCard: "Riks Presentkort",
            paymentType_MemberCard: "Medlemskort",
            paymentType_Manual: "Manuell",
            paymentType_PayPal: "PayPal",
            paymentType_MoneyBookers: "MoneyBookers",
            paymentType_BonusCard: "Bonuskort",
            paymentType_BonusCheck: "Bonuskupong",
            paymentType_BonusPoints: "Bonuspoäng",
            paymentType_InternalRefund: "Intern återbetalning",
            paymentType_ReplacementOrder: "Ersättningsorder",
            paymentType_MPOSBalance: "MPOS-saldo",
            paymentType_Profile: "Profil",
            paymentType_QLIRO: "QLIRO",
            paymentType_Swish: "Swish",
            paymentType_MiscOption1: "Annat alternativ 1",
            paymentType_MiscOption2: "Annat alternativ 2",
            paymentType_MiscOption3: "Annat alternativ 3",
            balanceAccountNo: "Balanskonto",
            global: "Global",
            retail: "Retail",
            mposManualCard: "Mpos manuellt kort",
            phoneNo: "Telefonnummer",
            totalValue: "Totalt värde",
            unitValue: "Styckvärde",
            inventoryValueReport: "Lagervärde rapport",
            inventoryQtyReport: "Lagerantal rapport",
            available: "Tillgängligt",
            reserved: "Reserverat",
            inventoryValue: "Lagervärde",
            debit: "Debet",
            accountSummary: "Konto sammanställning",
            accountDimension: "Konto Dimensioner",
            count: "Antal",
            date: "Datum",
            orderCountOverTime: "Order antal över tid",
            day: "Dag",
            week: "Vecka",
            month: "Månad",
            year: "År",
            gender: "Kön",
            fullDescription: "Lång Beskrivning (Body/HTML)",
            itemImport: "Artikelimport",
            import: "Importera",
            export: "Exportera",
            uploadFile: "Ladda upp fil",
            fileName: "Filnamn",
            prices: "Priser",
            variantInfo: "Variant information",
            dimensions: "Dimensioner",
            stock: "Saldo",
            stockInformation: "Lagersaldo",
            showDescriptions: "Visa beskrivningar",
            showAll: "Visa alla rader",
            showOnlyErrors: "Visa endast rader med fel",
            image: "Bild",
            variantReport: "Variantrapport",
            showExternalReferences: "Visa externa referenser",
            createReturn: "Skapa retur",
            info: "Information",
            trans: "Transnr.",
            refunded: "Återbetalt",
            returnLine: "Returnera rad",
            chooseRowsToReturn: "Välj rader att returnera",
            alreadyReturnedQuantity: "Redan returnerat antal",
            returnReason: "Returorsak",
            refundAmount: "Återbetalningsbelopp",
            remainingAmount: "Återstående belopp",
            posted: "Bokförd",
            showReturns: "Visa returer",
            returnFreight: "Returfrakt",
            amountToRefund: "Belopp att återbetala",
            returns: "Returer",
            noRowsLeftToReturn: "Det finns inga rader kvar att returnera",
            returnStatus_10: "Godkänd",
            returnStatus_0: "Preliminär",
            returnStatus_: "Preliminär",
            returnStatus: "Returstatus",
            show: "Visa",
            showOtherReturns: "Visa andra returer",
            showInvoicePayments: "Visa fakturabetalningar",
            showReplacement: "Visa ersättningsorder",
            createReplacementOrder: "Skapa ersättningsorder",
            openReplacementOrder: "Öppna ersättningsorder",
            replacementLines: "Ersättningsrader",
            refundPayments: "Återbetalningar",
            invoiceNo: "Fakturanr",
            returnNo: "Returnr",
            return: "Retur",
            invoiceLines: "Fakturarader",
            creditLines: "Kreditrader",
            cancelled: "Makulerad",
            creditedQuantity: "Krediterad kvantitet",
            refundedAmount: "Återbetalt belopp",
            editReturn: "Redigera retur",
            saved: "Sparat",
            field: "Fält",
            showOrderInfo: "Visa order info",
            showMoreInfo: "Visa mer info",
            orderInfo: "Order info",
            picked: "Plockat",
            packed: "Packat",
            qtyToPick: "Antal att plocka",
            qtyToPack: "Antal att packa",
            pick: "Plocka",
            pack: "Packa",
            dispatch: "Leverera",
            replacementOrder: "Ersättningsorder",
            showAdvancedControls: "Visa avancerade kontroller",
            scanOrClickToSetup: "Scanna eller klicka för att sätta upp MPOS",
            certificates: "Värdebevis",
            certificate: "Värdebevis",
            cancelCertificates: "Lös in värdebevis",
            cancelCertificatesDescription: "Lös in värdebevis som gått ut till valt datum.",
            startCancellation: "Starta makulering",
            progressAwaiting: "Väntar på status...",
            giftCard: "Presentkort",
            downPayment: "Handpenning",
            settlementVoucher: "Tillgodo",
            bonusCard: "Bonuskort",
            bonusCheck: "Bonuscheck",
            loading: "Laddar",
            appliesToDocumentNo: "Kopplas till dokumentnr",
            clearFilter: "Rensa filter",
            install: "Installera",
            key: "Nyckel",
            reInstall: "Ominstallera",
            advanced: "Avancerat",
            advancedUrls: "Avancerade urls",
            subScriberSettings: "Subscriber (händelser) inställningar",
            accountPlan: "Kontoplan",
            tag: "Tagg",
            systemLog: "Systemlogg",
            message: "Meddelande",
            method: "Metod",
            error: "Error",
            archive: "Arkiv",
            createNew: "Skapa ny",
            addColour: "Lägg till färg",
            addSize: "Lägg till storlek",
            addLength: "Lägg till längd",
            fetchTransactionsFrom: "Hämta transaktioner from.",
            remainingAmountGTE: "Återstående belopp större än",
            remainingAmountLTE: "Återstående belopp mindre än",
            updated: "Uppdaterad",
            createdby: "Skapad av",
            updatedby: "Uppdaterad av",
            showUserChangeInfo: "Visa förändringsinformation",
            redeem: "Lös in",
            redeemed: "Inlöst",
            importList: "Importlista",
            foundErrors: "Hittade fel",
            showVariants: "Visa varianter",
            creditNo: "Kreditnr.",
            validUntil: "Giltig t.o.m",
            activated: "Aktiverad",
            readyToShip: "Redo att levereras",
            myUser: "Min användare",
            billToCustomer: "Faktureras till kund",
            printTestLabel: "Skriv ut testetikett",
            labelSuggestAi: "Be AI föreslå etikettmall",
            labelChangeAi: "Be AI förändra etikettmall",
            jsonSuggestAi: "Be AI föreslå JSON-konfiguration",
            jsonChangeAi: "Be AI ändra JSON-konfiguration",
            run: "Kör",
            request: "Begäran",
            itemLabelBarcodeType: "Streckkodstyp",
            scanBarcode: "Skanna streckkod",
            scanAgain: "Skanna igen",
            scanningdotdot: "Skannar ...",
            showMore: "Visa mer",
            showLess: "Visa mindre",
            success: "Lyckades",
            variables: "Variabler",
            transfer: "Överföring",
            qtyToMove: "Antal att flytta",
            toLocation: "Till lagerställe",
            showAdvancedPrices: "Visa avancerade priser",
            createItemlabels: "Skapa artikeletiketter",
            createExchange: "Skapa byte",
            aiSuggest: "Be AI föreslå förändringar",
            updateExisting: "Uppdatera befintlig artikel",
            help: "Hjälp",
            county: "Region",
            inventoryDateLTE: "Lagerdatum t o m",
            inventoryDateGTE: "Lagerdatum fr o m",
            moreSalesPrices: "Fler Säljpriser",
            showContactInfo: "Visa kontaktinformation",
            emailSenderAddress: "Email avsändaraddress",
            custServiceEmail: "Kundtjänst email",
            custServicePhone: "Kundtjänst telefon",
            defaultEmail: "Standard email",
            requeue: "Köa om",
            requeueAll: "Köa om alla",
            orderErrors: "Order med error",
            showErrors: "Visa Errors",
            details: "Detaljer",
            setOrderAsSettled: "Sätt Order som settlad",
            remaining: "Återstående",
            bonusAccount: "Bonuskonto",
            externalCode: "Extern kod",
            salesPriceList: "Prislista",
            noFileSelected: "Ingen fil vald",
            importFile: "Importera fil",
            importData: "Importera data",
          },
          columns: {
            ext_Item: "Artiklar",
            ext_IntegrateItems: "Integrera artiklar",
            ext_Customer: "Kunder",
            ext_SalesOrder: "Försäljningsorder",
            ext_SalesOrderCancellation: "Försäljningsorder makulering",
            ext_SalesOrderInspection: "Försäljningsorder inspektion",
            ext_LockOrder: "Lås försäljningsorder",
            ext_LockSalesLines: "Lås orderrader",
            ext_LegacyInvoiceBilled: "Försäljningsfaktura och kredit",
            ext_SalesReturnIntegrated: "Försäljningsretur manuell integration",
            ext_SalesReturnCreated: "Försäljningsretur",
            ext_SalesReturnPostedTrx: "Försäljningsretur bokförd",
            ext_PurchaseOrder: "Inköpsorder",
            ext_PurchaseOrderIntegrated: "Inköpsorder manuell integration",
            ext_PurchaseOrderReceivedTrx: "Inleveranser",
            ext_PurchaseReturn: "Inköpsretur",
            ext_Inventory: "Lager",
            ext_Shipment: "Leveranser",
            ext_ShipmentTrackingUpdate: "Leverans tracking",
            ext_SalesOrderPickCompleted: "Försäljningsorder plock",
            ext_SalesOrderPackCompleted: "Försäljningsorder pack",
            ext_InternalOrderPosted: "Internorder leverans",
            ext_InternalOrderIntegrated: "Internorder manuell integration",
            ext_ShelfMove: "Hyllplatsflytt",
            ext_WarehouseLoadingCreated: "Lastorder",

          },
          integration: {
            bool_customer: "Intresse av kund skapande/uppdaterande",
            bool_salesorder: "Intresse av nya eller uppdaterar försäljningsordrar (öppna)",
            bool_cancel: "Intresse av makulerade försäljningsordrar",
            bool_inspection: "Intresse av försäljningsordersinspektion",
            bool_invoice: "Intresse av bokförda fakturor och kreditar",
            bool_lockorder: "Lås order för ändringar",
            bool_locklines: "Lås rader för ändringar",
            bool_return: "Intresse av integrerade försäljningsreturer",
            bool_returncreated: "Intresse av nya försäljningsreturer",
            bool_postedreturn: "Intresse av bokförda försäljningsreturer",
            bool_item: "Intresse av skapade/uppdaterade artiklar",
            bool_purchaseorder: "Intresse av nya skapade inköpsordrar",
            bool_purchaseManual: "Intresse av integrerade inköpsordrar",
            bool_receivepurchase: "Intresse av inlevererade inköpsordrar",
            bool_purchasereturn: "Intresse av inköpsreturer",
            bool_Inventory: "Intresse av lager (saldo)",
            bool_shipment: "Intresse av leveranser",
            bool_tracking: "Intresse av uppdaterad tracking information",
            bool_salesorderpickcomplete: "Intresse av eventet  {Sales Order Pick Complete}",
            bool_salesorderpackcomplete: "Intresse av eventet  {Sales Order Pack Complete}",
            bool_postedinternalorders: "Intresse av bokförda intern-ordrar",
            bool_integratedinternalorders: "Intresse av integrerade intern-ordrar",
            bool_shelfmove: "Intresse av eventet {Lagerflytt}",
            bool_warehouseloadingorder: "Intresse av nya skapade lastordrar",
            bool_itemsintegrate: "Intresse av att auto-integrera artiklar",
          },
          help: {
            paymentTermsHelp: "Betalningsvillkor, t.ex. 30 dagar",

            currencyHelp: "Valuta för dokumentet",

            shipToNameHelp: "Namn att leverera till",


            shipToName2Help: "Alternativt namn att leverera till",


            shipToAddressHelp: "Adress att leverera till",


            shipToAddress2Help: "Alternativ adress att leverera till",

            shipToMobileHelp: "Mobil för kontakt eller SMS vid leverans",


            shipToEmailHelp: "E-post för kontakt eller leveransinformation",


            shipToCountyHelp: "Region att leverera till",


            shipToPostCodeHelp: "Postnummer att leverera till",


            shipToCityHelp: "Stad att leverera till",


            shipToCountryHelp: "Land att leverera till, används även för tullinställningar",

            shipmentDateHelp: "Datum för leverans",
            shippingAgentHelp: "Välj fraktare, NShift/andra integrationer kopplas till detta val",

            shippingServiceHelp: "Välj vilken tjänst som används, inställningar och JSON för att skapa frakten",

            showPayments: "Visa betalningar",

            locationHelp: "Lagerställe att skicka produkter från",
            sellToCustomerHelp: "Kund att sälja varor till",
            billToCustomerHelp: "Kund att fakturera varor till",
            quantityRequired: "Antal är obligatoriskt",
            itemRequired: "Artikel är obligatorisk",
            qtyToShipRequired: "Antal att leverera är obligatoriskt",
            unitPriceRequired: "Styckpris är obligatoriskt",
            itemNoNoSpaces: "Artikelnummer får inte innehålla mellanslag.",
            description: "Beskrivning av artikel, används ofta ihop med färg/storlek i POS och webbshop",
            description2: "Alternativ beskrivning",
            fullDescription: "Längre beskrivning av artikel, kan innehålla HTML och används i webbshopens produktvisning",
            supplierItemNo: "Leverantörens artikelnummer, kan vara samma men är ofta olika",
            primarySupplier: "Primär leverantör för artikeln",
            barcode: "Streckkod för artikel, vanligtvis EAN13",
            salesPrice: "Primärt försäljningspris för produkten",
            salesPriceCurrency: "Valuta för försäljningspriset",
            purchasePrice: "Primärt inköpspris för produkten, används vid inköp",
            purchasePriceCurrency: "Valuta för inköpspriset",
            netWeight: "Nettovikt på endast varan, används för tull och frakt",
            grossWeight: "Bruttovikt för hela godset (inkl. emballage), används för tull och frakt",
            volume: "Volym på paketet, används för tull och frakt",
            statNo: "Stat-nr för tull, anger vad varan är",
            countryOfOrigin: "Var produkten är tillverkad",
            descriptionRequired: "Beskrivning är obligatorisk",
            salesPriceRequired: "Försäljningspris är obligatoriskt",
            purchasePriceRequired: "Inköpspris är obligatoriskt",
            nameRequired: "Namn är obligatoriskt",
            usernameRequired: "Användarnamn är obligatoriskt",
            passwordRequired: "Lösenord är obligatoriskt",
            usernameInfo: "Detta används för att logga in och är din identifierare",
            emailInfo: "Användarens e-post, används för lösenordsåterställning och kommunikation.",
            passwordInfo: "Ange endast om du vill sätta eller ändra lösenord. Det visas inte i vyn av säkerhetsskäl.",
            defaultLanguage: "Standardspråk",
            defaultCountry: "Standard land",
            itemLabelPrinter: "Skrivare för artikel-etiketter",
            shipmentLabelPrinter: "Skrivare för leveransetikett",
            addressLabelPrinter: "Skrivare för adressetikett",
            a4Printer: "Skrivare för A4",
            a5Printer: "Skrivare för A5",
            adjustLocation: "Lagerställe att justera",
            targetLocation: "Lagerställe att flytta till",
            addItemNo: "Artikelnummer att lägga till. Om ingen variant är vald, läggs alla ej spärrade varianter till",
            addBarcode: "Streckkod för artikel att lägga till i journalen",
            journalDescription: "Beskrivning för journalen",
            inventoryDate: "Datum som ska gälla för lagerjournalen",
            journalItemNoMultipleAddItem: "Artikelnummer att lägga till. Om ingen variant väljs läggs alla ej spärrade varianter till",
            estimatedQtyRequired: "Kvantitet är obligatoriskt",
            physicalQtyRequired: "Fysisk kvantitet är obligatoriskt",
            adjustmentRequired: "Justering är obligatoriskt",
            filterCustomer: "Filtrera för en specifik kund",
            filterSupplier: "Filtrera för en specifik leverantör satt på artikel",
            filterLocation: "Filtrera för ett specifikt lagerställe",
            filterItem: "Filtrera försäljning för en specifik artikel",
            connectedItemCategory: "Kopplad artikelkategori",
            optionalCodeGeneration: "Valfritt att ange, annars genererar systemet en kod",
            filterSalesCustomer: "Filtrera försäljning för en specifik kund",
            filterSalesSupplier: "Filtrera försäljning för en specifik leverantör",
            filterSalesShop: "Filtrera försäljning för en specifik butik",
            filterSalesSalesperson: "Filtrera försäljning för en specifik säljare",
            filterSalesCountry: "Filtrera försäljning för ett specifikt land",
            defaultCurrency: "Standardvaluta",
            shopNameInfo: "Butikens namn",
            shopNameRequired: "Butiksnamn krävs",
            defaultLanguageRequired: "Standardspråk krävs",
            defaultCurrencyRequired: "Standardvaluta krävs",
            defaultCountryRequired: "Standard land krävs",
            addressExtraInfo: "Valfri extra information för adressen, t.ex. våning 2.",
            companyAddress: "Företagets adress",
            companyName: "Företagets namn",
            codeRequired: "Kod krävs",
            supplierName: "Namn på leverantör",
            supplierNameAlt: "Alternativt namn",
            supplierAddress: "Adress till leverantör",
            supplierAddressAlt: "Alternativ adress till leverantör",
            supplierPhone: "Telefonnummer för kontakt och sms till leverantör",
            supplierEmail: "Används för kontakt och e-post till leverantör, t.ex. offert",
            supplierContact: "Extra kontaktperson för leverantör",
            supplierCurrency: "Valuta för leverantör, används på inköpsdokument",
            supplierLanguage: "Leverantörens språk. Används för e-post och dokument",
            shipToCustomer: "Kund som varorna skickades till",
            shippingAgent: "Detta väljer speditör, NShift/andra integrationer kopplas här",
            shippingService: "Detta väljer tjänsten som används, inklusive inställningar och JSON",
            accountNoSameAsSource: "Nytt kontonummer får inte vara samma som ursprung",
            accountNoRequired: "Kontonummer krävs",
            accountDescriptionRequired: "Kontobeskrivning krävs",
            accountTypeRequired: "Kontotyp krävs",
            postingSetupWhatRequired: "Bokföringsinställning Vad krävs",
            unitSameAsSource: "Ny enhet får inte vara samma som ursprung",
            unitRequired: "Enhet krävs",
            defaultSupplierPostingGroup: "Standard leverantörsbokföringsgrupp",
            defaultSupplierPostingGroupRequired: "Standard leverantörsbokföringsgrupp krävs",
            primaryEmail: "Företagets primära e-postadress.",
            companyCountry: "Företagets land",
            countryCodeSameAsSource: "Ny landskod får inte vara samma som ursprung",
            region: "Region i landet.",
            defaultCustomerLanguage: "Språk som alla kunder ärver",
            defaultCustomerCurrency: "Valuta som alla kunder ärver",
            currencyCodeRequired: "Valutakod krävs",
            currencyRateRequired: "Kurs krävs",
            paymentProvider: "Tjänst/leverantör för betalningar",
            paymentProviderRequired: "Betalleverantör krävs",

            paymentProviderSetting: "Inställning för betaltjänst",
            paymentProviderSettingRequired: "Betalleverantörsinställning krävs",

            cardTerminalIdRequired: "Terminal-ID krävs. Hämtas t.ex. från Adyen Terminal-Id",
            salesAccount: "Bokföringskonto som används för att bokföra försäljning",
            salesAccountRequired: "Försäljningskonto saknas",

            salesCreditAccount: "Bokföringskonto som används för kreditfakturor",
            salesDiscountAccount: "Bokföringskonto som används för rabatter på försäljning",

            salesVatAccount: "Bokföringskonto som används för moms på försäljning",
            salesVatAccountRequired: "Momsförsäljningskonto saknas",
            purchaseAccount: "Bokföringskonto som används för inköp",
            purchaseCreditAccount: "Bokföringskonto för inköpskreditnotor",
            purchaseDiscountAccount: "Bokföringskonto för inköpsrabatter",
            purchaseReceivalAccount: "Konto för mottagna men ej fakturerade varor",
            purchaseOverheadAccount: "Konto för generella inköpsomkostnader",
            purchaseVatAccount: "Momskonto för inköp",
            purchaseReverseVatAccount: "Omvänd moms konto för inköp",
            cogsAccount: "Konto för sålda varors kostnad",
            transferBalanceAccount: "Saldoöverföringskonto",
            inwardGoodsAccount: "Konto för mottagna varor",
            inwardServiceAccount: "Konto för mottagna tjänster",
            inwardGoodsVatAccount: "Momskonto för mottagna varor",
            inwardServiceVatAccount: "Momskonto för mottagna tjänster",
            inventoryValueAdjustmentAccount: "Konto för lagerjusteringar",
            purchaseOverheadCustomsAccount: "Inköpsomkostnadskonto för tull",
            purchaseOverheadOtherAccount: "Inköpsomkostnadskonto för övrigt",
            purchaseOverheadFreightAccount: "Inköpsomkostnadskonto för frakt",
            externalReference: "Används för att matcha mot externa system",
            vatPercentage: "Momsprocent som används i transaktionen, t.ex. 25",
            postingSetupWhat: "Bokföringsgrupp för varor/tjänster (vad du säljer)",
            postingSetupWho: "Bokföringsgrupp för kunder/leverantörer (vem du säljer till)",
            salespersonCodeSame: "Ny säljkod kan inte vara samma som källan",
            posPincode: "Pinkod för att logga in i POS",
            posLanguage: "Språk du vill se POS i",
            priceGroupShop: "Prisgrupp som avgör vilken prislista som används, t.ex. 'Konsument'",
            terminalShop: "Butik kopplad till terminal",
            cardTerminal: "Vilken kortterminal enheten ska kommunicera med",
            thermalPrinter: "Skrivare för kvitton",
            defaultLocationRequired: "Standard lagerställe krävs",
            defaultPriceGroupRequired: "Standard prisgrupp krävs",
            defaultPostingGroupWhoRequired: "Standard bokföringsgrupp vem krävs",
            defaultPostingGroupWhatRequired: "Standard bokföringsgrupp vad krävs",
            customerRequired: "Kund krävs",
            locationRequired: "Lagerställe är obligatorisk.",
            targetLocationRequired: "Till lagerställe är obligatorisk.",
            apiUsername: "Användarnamn för API-anrop (återbetalning).",
            apiPassword: "Lösenord för API-anrop (återbetalning).",
            refundUrl: "URL som används vid återbetalning via API.",
            settlementUrl: "URL som används vid slutförande av betalning (Settling).",
            apiKey: "API-nyckel för slutförande av betalning authorize och capture.",
            merchantAccount: "Merchant Account som används av både återbetalning och Settling.",
            adyenPrefix: "Prefixen som används i Adyen-URL:en, vanligtvis ditt konto-ID eller organisationsnamn.",
            adyenSecret: "Hemlig API-nyckel som används för att autentisera Adyen-anrop (t.ex. capture, refund).",
            paypalApiUrl: "API-endpoint för PayPal-anrop (t.ex. återbetalningar, betalningar).",
            paypalApiUsername: "Ditt PayPal API-användarnamn för autentisering.",
            paypalApiPassword: "Ditt PayPal API-lösenord som används vid säkra anrop.",
            paypalApiSignature: "Din PayPal API-signatur som verifierar att anropet kommer från dig.",
            fallbackKey: "Nyckel {{index}} används olika beroende på integration.",
            klarnaMerchantId: "Merchant ID tillhandahållet av Klarna.",
            klarnaSharedSecret: "Används för att signera och verifiera kommunikation med Klarna.",
            klarnaBaseUrl: "API-bas-URL för Klarna (t.ex. https://api.playground.klarna.com).",
            klarnaCheckoutType: "Välj om konfigurationen är för Klarna Checkout (KCO) eller Klarna Payments (KP).",
            klarnaTermsUrl: "Valfritt. Länk till butikens köpvillkor.",
            klarnaConfirmationUrl: "Valfritt. URL dit Klarna ska skicka kunden efter slutförd betalning.",
            klarnaCheckoutUrl1: "Valfritt. URL för att initiera Klarnas checkout.",
            klarnaCheckoutUrl2: "Valfritt. Alternativ URL för checkoutflöde vid behov av flera steg.",
            balanceAccount: "Kontot som betalningen bokas mot, för att balansera försäljningen.",
            "customerName": "Kundens namn, används för att adressera och identifiera mottagaren",
            "customerNameAlt": "Alternativt namn för kunden, om tillämpligt (t.ex. c/o eller företag)",
            "customerAddress": "Primär adress dit leverans och kommunikation ska skickas",
            "customerAddressAlt": "Alternativ adress om leverans ska gå till annan plats än huvudadressen",
            "customerCountry": "Det land där kunden är baserad",
            "customerPhone": "Telefonnummer till kunden, används för kontakt och aviseringar",
            "customerEvents": "Används för att notifiera kunden om olika händelser i systemet",
            invalidFile: "Filen saknas eller är felaktig",
            salesPriceImportDescription: "Ladda upp en CSV-fil för att validera och importera försäljningspriser.",
            noImportLines: "Inga importrader finns ännu.",
            importCompleteMessage: "Importen är klar. Du kan granska resultatet ovan.",
            importRowHasErrors: "Denna rad innehåller ett eller flera fel",
            downloadExcel: "Ladda ner Excel",
            quantityHigherThanReturnable: "Antal kan inte vara högre än tillgängligt returbart antal",
            amountRequired: "Belopp krävs",
            invalidQuantity: "Felaktig kvantitet",
            quantityExceedsReturnable: "Endast {{max}} kan returneras – överskottet ignoreras.",

            suggestAiLabelHelp: "Ange en begäran om vad du vill att AI ska generera. Till exempel: 'Skapa en mall för en artikel­etikett med artikelnummer, streckkod, pris och valuta'.",
            suggestAiJsonHelp: "Beskriv hur du vill att JSON-konfigurationen för frakt ska ändras. Nämn viktiga variabler eller värden som ska ingå.",
            labelJournalAdvancedPrices: "Sätt prissgrupp och valuta ifall du vill ha fler än ett pris på en etikett",
            countryRequired: "Land är obligatoriskt",
            suggestItemHelp: "Ange en begäran om hur du vill att ai ska generera en artikel. Nuvarande artikel används som bas",
            updateExisting: "Bestämmer ifall AI uppdaterar befintlig artikel eller skapar ny artikel.",

            defaultEmail: "Standard email",
            emailSenderAddress: "Email som används för utgående kommunikation",
            custServiceEmail: "Email som används för kundtjänst",
            custServicePhone: "Telefonnummer som används för kundtjänst",
            templateCustomer: "Mallkund där inställningar kopieras ifrån till nya köp och kunder",
            templateCustomerRequired: "Mallkund krävs",
            dimension1: "Dimension som ofta används för att indikera var en försäljning gjorts. Exempelvis kanal eller butik",
            defaultIntegrationFlavour: "Standard integrationen skapas som skal där du själv kan fylla i alla nycklar och inställningar som behövs",
            defaultPriceGroup: "Standard prisgrupp som används i bex, kan även sättas på kund som då styr",
            defaultPostingGroupWho: "Standard bokföringsgrupp Vem, kan även sättas på kund som då styr",
            qliroUrl: "Url som används för integration, ges av Qliro.",
            qliroMerchantApiKey: "Din Qliro Merchant Api Key, ges av Qliro.",
            qliroSecret: "Din Qliro Secret, ges av Qliro.",
            defaultCustomerPostingGroup: "Standard kundbokföringsgrupp som används i bex,  kan även sättas på kund som då styr",
          },
          dialog: {
            lineSaved: "Raden sparades!",
            lineSaveError: "Fel vid sparning av rad",
            deleteRowConfirm: "Är du säker på att du vill ta bort denna rad?",
            rowDeleted: "Rad borttagen",
            rowDeleteError: "Fel vid borttagning av rad",
            allRowsDeleted: "Alla rader borttagna",
            saveBeforeLines: "Spara dokumentet innan du redigerar rader",
            selectVariant: "Kan inte lägga till artikel med varianter, välj en variant.",
            rowsDeleteError: "Fel vid borttagning av rader",
            paymentSaved: "Betalning sparades",
            failedToSaveChanges: "Misslyckades med att spara ändringar",
            paymentDeleted: "Betalning togs bort",
            paymentDeleteError: "Misslyckades med att ta bort betalning",
            mobileRequired: "Vänligen fyll i mobilnummer i dokumentet innan du fortsätter.",
            paymentInitError: "Fel vid initiering av betalning",
            paymentSuccess: "Betalning lyckades",
            paymentDenied: "Betalning nekades",
            awaitingConfirmation: "Väntar på bekräftelse",
            statusFetchError: "Fel vid hämtning av status",
            statusUnknown: "Okänd betalningsstatus",
            paymentFetchError: "Misslyckades med att hämta uppdaterad betalning",
            paymentInitialized: "Betalning initierad",
            itemNotFoundWithDefault: "Ingen artikel hittades för artikelnummer: {{no}}. Initierar med standardvärden.",
            itemFetchError: "Misslyckades med att hämta artikel",
            settingNewItem: "skapar ny artikel",
            fixErrors: "Vänligen åtgärda följande fel:",
            itemSaved: "Artikeln sparades!",
            variantsSaved: "Alla varianter sparades",
            itemCopied: "Artikeln kopierades!",
            deleteItemConfirm: "Är du säker på att du vill ta bort denna artikel?",
            itemDeleted: "Artikeln togs bort!",
            itemDeleteError: "Misslyckades med att ta bort artikel",
            imageUploaded: "Bild uppladdad!",
            imageUploadError: "Misslyckades med att ladda upp bilden. Försök igen.",
            fileUploadError: "Misslyckades med att ladda upp filen. Försök igen.",
            cannotCopyPreliminaryItem: "Kan inte kopiera preliminär artikel, spara först",
            editItem: "Redigera artikel",
            createNewItem: "Skapa ny artikel",
            enterValidDescription: "Vänligen fyll i en giltig beskrivning",
            optionExists: "Detta alternativ finns redan.",

            savedSuccessfully: "Sparades",
            saveErrorGeneric: "Fel vid sparning. Försök igen.",

            variantSaved: "Variant sparades",
            variantSaveError: "Fel vid sparning av variant",

            variantAddNoSelection: "Kunde inte lägga till variant. Ingen variant vald.",
            variantAddColorMissing: "Kunde inte lägga till variant. Färgkod krävs.",
            variantAddSizeMissing: "Kunde inte lägga till variant. Storlekskod krävs.",
            variantAddLengthMissing: "Kunde inte lägga till variant. Längdkod krävs.",

            variantRemoved: "Variant togs bort",
            variantDeleted: "Variant borttagen",
            variantDeleteError: "Misslyckades med att ta bort variant",
            navigateToGroupConfirm: "Är du säker på att du vill navigera till {{groupName}}?",

            failedToFetchData: "Misslyckades med att hämta data",
            failedDelete: "Misslyckades med att ta bort",
            userMissing: "Användardata saknas.",
            nameRequired: "Namn är obligatoriskt.",
            usernameRequired: "Användarnamn är obligatoriskt.",
            emailRequired: "E-postadress är obligatorisk.",
            passwordRequired: "Lösenord är obligatoriskt.",
            cannotCopyPreliminary: "Kan inte kopiera preliminärt objekt, spara först",
            usernameSameAsSource: "Nytt användarnamn får inte vara samma som originalet",
            userCopied: "Användare kopierades!",
            deleteEntityConfirm: "Är du säker på att du vill ta bort detta objekt?",
            userDeleted: "Användare togs bort!",
            journalCreateError: "Misslyckades med att skapa journal",
            inventoryMissing: "Inventeringsdata saknas.",
            locationRequired: "Lagerställe är obligatorisk.",
            saveBeforeContinuing: "Spara bonussystemet innan du fortsätter",
            valueRequired: "Värde krävs",
            noItemOrBarcode: "Ingen artikel eller streckkod vald, kan inte lägga till",
            addingItems: "Lägger till artikel/artiklar",
            addLineError: "Misslyckades med att lägga till rad",
            confirmDeleteAllLines: "Är du säker på att du vill ta bort alla rader?",
            fetchLinesError: "Fel vid hämtning av rader",
            deletedSuccessfully: "Lyckades ta bort entitet.",
            deleteFailed: "Misslyckades med att ta bort.",
            descriptionRequired: "Beskrivning krävs",
            itemCategoryRequired: "Artikelkategori krävs",
            fetchStatusError: "Fel vid hämtning av status",
            graphEmpty: "Diagrammet är nu tomt",
            graphRemoveItem: "Tog bort",
            graphAddItem: "Lade till",
            downloadSuccess: "Dokument nedladdat!",
            fetchServiceJsonError: "Misslyckades med att hämta service-json",
            companySetupSuccess: "Företag och butik har konfigurerats.",
            companyDataMissing: "Företagsdata saknas.",
            companyNameRequired: "Företagsnamn krävs.",
            companyCurrencyRequired: "Företagsvaluta krävs.",
            companyLanguageRequired: "Företagsspråk krävs.",
            shopDataMissing: "Butiksdata saknas.",
            shopNameRequired: "Butiksnamn krävs.",
            createJournalError: "Misslyckades med att skapa journal",
            fetchSupplierError: "Misslyckades med att hämta leverantör",
            loginFailed: "Inloggning misslyckades.",
            invalidRequest: "Ogiltig inloggningsförfrågan.",
            accountLocked: "Kontot är låst på grund av för många misslyckade försök.",
            invalidCredentials: "Fel användarnamn eller lösenord.",
            accountDataMissing: "Kontodata saknas.",
            accountNoRequired: "Kontonummer krävs.",
            accountDescriptionRequired: "Beskrivning krävs.",
            accountTypeRequired: "Kontotyp krävs.",
            copyPreliminaryAccount: "Kan inte kopiera preliminärt konto, spara först",
            accountNoSameAsSource: "Nytt kontonummer får inte vara samma som ursprung",
            accountCopiedSuccess: "Konto kopierat!",
            accountCopyError: "Misslyckades med att kopiera konto",
            accountNoEmpty: "Kontonummer får inte vara tomt",
            accountDescriptionEmpty: "Beskrivning får inte vara tom",

            fetchCompanyError: "Misslyckades med att hämta företag",
            unitRequired: "Enhet krävs.",
            currencyRequired: "Valuta krävs.",
            languageRequired: "Språk krävs.",
            priceGroupRequired: "Prisgrupp krävs.",
            postingGroupWhoRequired: "Bokföringsgrupp (vem) krävs.",
            customerPostingGroupRequired: "Kundens bokföringsgrupp krävs.",
            supplierPostingGroupRequired: "Leverantörens bokföringsgrupp krävs.",
            copyPreliminaryCompany: "Kan inte kopiera preliminärt företag, spara först",
            unitSameAsSource: "Ny enhet får inte vara samma som ursprung",
            copySuccess: "Enhet kopierades!",
            copyError: "Misslyckades med att kopiera enhet",
            unitEmpty: "Enhet får inte vara tom",
            copyPreliminaryCountry: "Kan inte kopiera preliminärt land, spara först",
            countryCodeSameAsSource: "Nytt landskod får inte vara samma som ursprung",
            dataMissing: "Data saknas.",
            codeEmpty: "Kod får inte vara tom",
            currencyCodeRequired: "Valutakod krävs.",
            currencyDescriptionRequired: "Beskrivning krävs.",
            currencyRateRequired: "Kurs krävs.",
            copyPreliminaryLocation: "Kan inte kopiera preliminärt lagerställe, spara först",
            postingGroupWhatOrWhoRequired: "Bokföringsinställning vad eller vem krävs",
            salesAccountMissing: "Försäljningskonto saknas",
            salesVatAccountMissing: "Momsförsäljningskonto saknas",
            activatePrintNodeFailed: "Misslyckades med att aktivera Print Node",
            salespersonCopyPreliminary: "Kan inte kopiera preliminär säljare, spara först",
            salespersonCodeSame: "Nytt säljkod kan inte vara samma som källan",
            salespersonCopied: "Säljare kopierad!",
            salespersonCopyFailed: "Misslyckades med att kopiera säljare",
            enterNewCode: "Ange ny kod",
            copyPreliminaryEntity: "Kan inte kopiera preliminär enhet, spara först",
            entityCopied: "Kopierad!",
            copyFailed: "Misslyckades med att kopiera",
            codeRequired: "Kod får inte vara tom",
            fixJsonBeforeSave: "Åtgärda JSON-fel innan du sparar.",
            invalidJsonReset: "Ogiltigt JSON-format mottaget. Återställer till tomt.",
            sectionAdded: "Sektion tillagd.",
            sectionAlreadyExists: "Sektion finns redan.",
            invalidJsonBeforeSave: "Ogiltigt JSON-format. Åtgärda fel innan du sparar.",
            shopRequired: "Butik är obligatorisk.",
            refundIncomplete: "Fyll i alla fält för återbetalning om du vill konfigurera den.",
            settlingIncomplete: "Fyll i alla fält för Settling inklusive Merchant Account.",
            balanceAccountRequired: "Balanskonto krävs",
            missingLocation: "Lagerställe saknas",
            successCreatedReturn: "Retur skapades",
            failedToCreateReturn: "Misslyckades med att skapa retur",
            invalidReturn: "Ogiltig retur, välj rader att returnera först",
            missingFilters: "Saknar Filter",
            areYouSure: "Är du säker?",
            customerAnonymizedQueued: "Kunden är schemalagd för att bli anonymiserad, kommer ske efter 00:00 (midnatt)",
            selectItem: "Välj artikel",
            selectAccount: "Välj konto",
            fortNoxReAuthError: "Fortnox behöver om auktoriseras. Var god ominstallera.",
            fortNoxAccountInactive: "Ett konto som skickades till fortnox är inaktiv, därför har integrationen stoppats. Vänligen aktivera kontot under (kontoplan) i Fortnox, se mer info i systemlog",
            fortNoxAccountMissing: "Ett konto som skickades till Fortnox saknas, vänligen kontrollera kontot under (kontoplan) i Fortnox, ser mer info i systemlog",
            fortnoxInstallMessage: "Genom att klicka på Installera omdirigeras du till Fortnox där du loggar in och installerar applikationen. När du återvänder konfigurerar vi integrationen och den startar automatiskt.",
            fortnoxInstallSuccess: "Fortnox-integrationen har installerats framgångsrikt.",
            fetchDataError: "Misslyckades att hämta data",
            itemImportSuccess: "Artikelimport lyckades",
            importSuccessText: "Importen lyckades, samtliga rader har nu importerats",
            importSuccessFlavor: "Du kan nu granska dina artiklar eller gå tillbaka till listan för att fortsätta arbeta.",
            importGoToList: "Gå till artikellistan",
            importStay: "Stanna",
            cannotChangeCompletedLine: "Du kan inte ändra en färdig rad",
            noLinesToHandle: "Inga rader att hantera",
            actionSuccess: "Händelsen lyckades",
            missingCustomer: "Kund saknas",
            queuedForPrint: "Köad för utskrift",
            missingPrompt: "Saknar arbetsbeskrivning till AI",
            doYouWishToCreateALabelJournal: "Vill du skapa en etikettjournal för denna inleverans?",
            chooseIntegrationType: "Välj integrationstyp",
            requiredFields: "Krävande fält",
          },
          actions: {
            addItem: "Lägg till artikel",
            addAccount: "Lägg till konto",
            addCertificate: "Lägg till värdebevis",
            addText: "Lägg till text",
            deleteAll: "Ta bort alla rader",
            addPayment: "Lägg till betalning",
            payByLink: "Betala via länk",
            addToReturn: "Lägg till i retur",
          },
          graph: {
            orderGraphTitle: "Orderantal över tid",
            orderGraphSummaryTitle: "Analys",
            orderGraphDescription: "Grafen visar antal lagda orders per dag under vald tidsperiod. Den hjälper till att identifiera trender, säsongsvariationer och effekten av kampanjer eller marknadsföringsinsatser.",
            orderExtraInfo: "Data uppdateras dagligen från ordersystemet och inkluderar alla orders från webb, kassasystem och manuella registreringar. Helgdagar och helger kan påverka volymen naturligt.",

            itemGraphTitle: "Topp 10 artiklar",

            itemGraphSummaryTitle: "Insikt",
            itemGraphDescription: "Diagrammet visar de 10 mest sålda artiklarna under vald period, sorterade efter antal sålda. Användbart för att analysera produktprestanda och identifiera hög efterfrågan.",
            itemExtraInfo: "Inkluderar alla aktiva försäljningskanaler och ordertyper. Artiklar med samma namn grupperas. Data speglar endast slutförda transaktioner.",
            programGraphTitle: "Försäljning per program",
            programGraphSummaryTitle: "Program",
            programGraphDescription: "Visar omsättning per program under vald period.",
            programExtraInfo: "Endast slutförda transaktioner räknas med.",
            countryGraphTitle: "Försäljning per land",
            countryGraphSummaryTitle: "Fördelning",
            countryGraphDescription: "Visar omsättning per kundland under vald period.",
            countryExtraInfo: "Baseras på faktureringsland från säljdokument. Endast slutförda transaktioner inkluderas.",
            shopAvgGraphTitle: "Säljantal snitt per butik",
            shopAvgValueGraphTitle: "Säljbelopp snitt per butik",
            shopReturnFreqGraphTitle: "Returfrekvens per butik",
            productGroupGraphTitle: "Försäljning per produktgrupp",
            itemCategoryGraphTitle: "Försäljning per artikelkategori",
            itemGroupGraphTitle: "Försäljning per artikelgrupp",
            dimensionGraphTitle: "Försäljning per dimension",
          },
          graphBuilder: {
            title: "Anpassa dashboard",
            save: "Spara",
            editDashboard: "Ändra grafer"
          }
        }
      }

    }
  });

export function changeLanguage(newLang: string) {
  // change here
  i18n.changeLanguage(newLang);
  // update localStorage for persistence + cross-tab
  localStorage.setItem(LANG_KEY, newLang);
}

window.addEventListener("storage", e => {
  if (e.key === LANG_KEY && e.newValue) {
    console.log("lang changed");
    i18n.changeLanguage(e.newValue);
  }
});